<template>
  <div class="model-type-card">
    <v-container fluid style="padding: 12px">
      <div style="display: flex; align-items: center; margin-top: -20px">
          <div class="model-header-title-group">
          <img v-if="!localEditAction" src="@/assets/ic_round-plus-black.svg" alt="img" width="24" height="24" />
          <span style="font-size: 24px; font-weight: 600">
            {{ page == 'view model' ? $t('viewModel') : localEditAction != null ? (localEditAction ? $t('updateModel') : $t('createModel')) : $t('createModel') }}
          </span>
        </div>
          <v-chip v-if="LLmsModel.modelDisplay" id="modelID-modelmanagement" class="model-id-chip" variant="flat" pill>
            <span class="model-id-chip__text">{{ $t("modelId") }}: {{ LLmsModel.modelDisplay }}</span>
          </v-chip>

          <v-menu v-model="categoryMenuOpen" :close-on-content-click="false" offset="6" location="bottom start">
            <template v-slot:activator="{ props }">
              <v-btn id="category-menu-trigger-modelmanagement" v-bind="props" variant="text" size="small" class="category-menu-trigger">
                <v-icon size="18" :color="LLmsModel.categoryName ? '#1976D2' : '#94a3b8'" class="me-1">mdi-tag-outline</v-icon>
                <span class="category-menu-text" :class="{ 'category-menu-text--placeholder': !LLmsModel.categoryName }">
                  {{ LLmsModel.categoryName || $t('category') }}
                </span>
                <v-icon size="16" color="#94a3b8" class="ms-1">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list density="compact" class="category-menu-list" :max-height="320">
              <v-list-item @click.stop="openAddCategoryDialog" class="category-menu-new">
                <template #prepend>
                  <v-icon color="primary" size="18">mdi-tag-plus-outline</v-icon>
                </template>
                <v-list-item-title class="category-menu-new__title">{{ $t("newCategory") }}</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item v-if="LLmsModel.categoryName" @click="selectCategoryFromHeader(null)">
                <template #prepend>
                  <v-icon size="18" color="#94a3b8">mdi-close-circle-outline</v-icon>
                </template>
                <v-list-item-title>{{ $t("clearCategory") }}</v-list-item-title>
              </v-list-item>
              <v-divider v-if="LLmsModel.categoryName" />
              <v-list-item v-if="categoryOptions.length === 0">
                <v-list-item-title class="category-menu-empty">{{ $t("noCategoriesYet") }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in categoryOptions"
                :key="item.name"
                :active="LLmsModel.categoryName === item.name"
                @click="selectCategoryFromHeader(item.name)"
              >
                <template #prepend>
                  <v-icon size="15" color="#1976D2">mdi-tag-outline</v-icon>
                </template>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        <div class="publication-header-wrapper">
          <div class="publication-header-controls">
            <v-chip class="publication-status-chip" :color="LLmsModel.isPublish ? '#2ABF56' : '#C1C3CB'" variant="elevated" size="45" pill>
              <span class="text-capitalize" style="color: #ffffff !important">
                {{ LLmsModel.isPublish ? $t('published') : $t('draft') }}
              </span>
            </v-chip>

            <span class="publication-label">{{ $t("publicationControl") }}</span>

            <v-switch id="publication-header-switch" class="memory-switch mt-6" v-model="LLmsModel.isPublish" />

            <span class="publication-version text-capitalize">{{ $t('versionLabel') }} {{ LLmsModel.versioning || '1' }}</span>
          </div>
        </div>
      </div>
      <div style="margin-top: -12px">
        <hr />
      </div>
      <v-form class="mt-6" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-container fluid>
                <v-row>
                  <!-- Model Type & Name Card -->
                  <v-col cols="12">
                    <v-row class="model-input-group" align="start">
                      <v-col cols="8">
                        <v-row align="start">
                          <!-- Model Name -->
                          <v-col cols="6" class="model-input-col">
                            <span>{{ $t("modelName") }} <span style="color: red">*</span> </span>
                            <v-text-field
                              id="modelname-field-modelmanagement"
                              v-model="LLmsModel.modelName"
                              :rules="[rules.required]"
                              required
                              density="compact"
                              variant="none"
                              :placeholder="$t('modelName')"
                              persistent-hint
                              class="model-input-control"
                            >
                            </v-text-field>
                          </v-col>

                          <!-- Model -->
                          <v-col cols="6" class="model-input-col">
                            <!-- ปุ่ม Test Model อยู่บรรทัดเดียวกับ label (ความสูง <= label) ช่อง Model จึงตรงกับ Model Name และไม่ตกบรรทัดตามความกว้างจอ -->
                            <div class="model-field-label-row">
                              <span>{{ $t("model") }} <span style="color: red">*</span> </span>
                              <button
                                id="test-model-button-modelmanagement"
                                type="button"
                                class="model-probe-test-btn"
                                :class="{ 'model-probe-test-btn--running': isProbing }"
                                :disabled="!canRunModelProbe"
                                @click="onClickTestModel"
                              >
                                <v-progress-circular v-if="isProbing" indeterminate size="12" width="2" class="me-1"></v-progress-circular>
                                <v-icon v-else icon="mdi-flask-outline" size="14" class="me-1"></v-icon>
                                {{ $t('_probeTestButton') }}
                              </button>
                            </div>
                            <v-autocomplete
                              id="model-autocomplete-modelmanagement"
                              v-model="LLmsModel.model"
                              :items="modelSelectionOptions"
                              item-title="modelDisplay"
                              item-value="modelName"
                              :rules="modelSelectionRules"
                              :no-data-text="modelNoDataText"
                              required
                              density="compact"
                              variant="none"
                              :placeholder="$t('model')"
                              @update:model-value="handleModelChange"
                              persistent-hint
                              clearable
                              class="model-input-control"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item placeholder="Model" v-bind="props" :id="'model-gptmodeldetail-option-' + index" :value="item.raw.modelName" :title="getModelSelectionDisplay(item.raw)">
                                  <template v-slot:subtitle>
                                    <div class="model-option-subtitle">
                                      <span class="model-option-meta">
                                        <span class="model-option-meta-value">{{ item.raw.platform || '-' }}</span>
                                      </span>
                                      <span class="model-option-meta-separator">/</span>
                                      <span class="model-option-meta">
                                        <span class="model-option-meta-value">{{ item.raw.provider || '-' }}</span>
                                      </span>
                                    </div>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:selection="{ item }">
                                <span class="model-selection-title">{{ getModelSelectionDisplay(item.raw) }}</span>
                              </template>
                            </v-autocomplete>
                            <div v-if="modelInlineNotice" id="model-sampling-notice-modelmanagement" class="model-probe-inline" :class="'model-probe-inline--' + modelInlineNotice.tone">
                              <span>{{ modelInlineNotice.text }}</span>
                            </div>
                            <div v-if="selectedModelInfo" id="model-probe-bar-modelmanagement" class="model-provider-details">
                              <span class="model-provider-pill">
                                <v-icon icon="mdi-server-network" size="14" color="primary" class="me-1"></v-icon>
                                <span class="model-provider-label">{{ $t("platform") }}</span>
                                <span class="model-provider-value">{{ selectedModelInfo.platform || '-' }}</span>
                              </span>
                              <span class="model-provider-pill">
                                <v-icon icon="mdi-cloud-outline" size="14" color="primary" class="me-1"></v-icon>
                                <span class="model-provider-label">{{ $t("Provider") }}</span>
                                <span class="model-provider-value">{{ selectedModelInfo.provider || '-' }}</span>
                              </span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>

                      <!-- Model Type and model name-->
                      <v-col cols="4">
                        <v-row>
                          <div class="flexAllCenter mx-8">
                            <div class="custom-vertical-divider"></div>
                          </div>
                          <!-- Model Type -->
                          <div style="display: flex; flex-direction: column; justify-content: flex-start !important; width: 80%">
                            <span>{{ $t("modelType") }} <span style="color: red">*</span> </span>
                            <div class="model-type-toggle-container">
                              <v-btn-toggle v-model="LLmsModel.typeLLM" class="model-type-toggle" density="compact">
                                <v-btn id="button-bot-modelmanagement" :value="0" class="model-type-btn" :disabled="localEditAction"><span style="font-weight: 600; font-size: 16px">{{ $t("bot") }}</span></v-btn>
                                <v-btn id="button-guardrail-modelmanagement" :value="1" class="model-type-btn" :disabled="localEditAction"
                                  ><span style="font-weight: 600; font-size: 16px">{{ $t("guardRail") }}</span></v-btn
                                >
                              </v-btn-toggle>
                            </div>
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- Description - Full Width -->
                      <v-col cols="12" class="mt-3" style="display: flex; flex-direction: column">
                        <span>{{ $t("description") }}</span>
                        <v-textarea
                          id="description-textarea-modelmanagement"
                          v-model="LLmsModel.description"
                          density="compact"
                          variant="none"
                          auto-grow
                          rows="1"
                          :placeholder="$t('_descriptionPlaceholder')"
                          persistent-hint
                          class="description-field"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <transition name="fade">
                        <div v-if="txtToImgChecker" class="image-settings-container mb-4" style="width: 100%">
                          <!-- Enhanced Header -->
                          <v-card class="image-settings-card">
                            <v-card-title>
                              <div class="d-flex align-center justify-start gap-2">
                                <img src="@/assets/mynaui_image-solid.svg" alt="img" width="24" height="24" class="mr-3" />
                                <h3 style="font-weight: 700; color: #171717">{{ $t("imageGenerationSettings") }}</h3>
                              </div>
                              <span style="color: #646464; font-size: 16px">{{ $t("_configureImageParams") }}</span>
                            </v-card-title>

                            <div class="pa-4">
                              <hr />
                            </div>

                            <!-- Enhanced Content -->
                            <v-card-text class="pa-6">
                              <v-row class="image-settings-row">
                                <!-- Style Selection -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/fluent_style-guide-24-regular.svg" alt="img" width="18" height="18" />
                                    <label for="Image Style" style="color: #171717; font-size: 16px">{{ $t("imageStyle") }}</label>
                                    <span style="color: red; margin-left: 4px">*</span>
                                    <v-tooltip location="top" max-width="230px">
                                      <template v-slot:activator="{ props }">
                                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                                      </template>
                                      <span>{{ $t("_tipImageStyle") }}</span>
                                    </v-tooltip>
                                  </div>

                                  <v-select
                                    id="imagestyle-select-modelmanagement"
                                    v-model="LLmsModel.styleImage"
                                    :items="imageStyleOptions"
                                    item-title="text"
                                    item-value="value"
                                    :rules="[rules.required]"
                                    variant="none"
                                    density="compact"
                                    required
                                    class="model-input-control"
                                    style="margin-top: -3px"
                                    :placeholder="$t('chooseImageStyle')"
                                  >
                                    <template v-slot:selection="{ item }">
                                      <div class="d-flex align-center">
                                        <span class="font-weight-medium">{{ item.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item }">
                                      <v-list-item v-bind="props" class="style-item">
                                        <template v-slot:prepend>
                                          <v-avatar :color="item.raw.value === 'natural' ? 'green lighten-4' : 'orange lighten-4'" size="32">
                                            <v-icon size="16" color="white">
                                              {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                            </v-icon>
                                          </v-avatar>
                                        </template>
                                        <template v-slot:title>
                                          <span class="font-weight-medium">{{ item.raw.text }}</span>
                                        </template>
                                        <template v-slot:subtitle>
                                          <span class="text-caption">
                                            {{ item.raw.value === 'natural' ? $t('_styleNatural') : $t('_styleVivid') }}
                                          </span>
                                        </template>
                                      </v-list-item>
                                    </template>
                                  </v-select>
                                </v-col>

                                <!-- Quality Setting -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/mdi_quality-high.svg" alt="img" width="18" height="18" />
                                    <label for="Image Quality">{{ $t("imageQuality") }}</label>
                                  </div>

                                  <v-autocomplete :placeholder="$t('qualityLevel')" variant="none" density="compact" disabled v-model="LLmsModel.quality" class="model-input-control" readonly>
                                  </v-autocomplete>
                                </v-col>

                                <!-- Resolution Setting -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/eva_monitor-outline.svg" alt="img" width="18" height="18" />
                                    <label for="Image Resolution">{{ $t("imageResolution") }}</label>
                                    <v-tooltip location="top" max-width="230px">
                                      <template v-slot:activator="{ props }">
                                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                                      </template>
                                      <span>{{ $t("_tipImageResolution") }}</span>
                                    </v-tooltip>
                                  </div>

                                  <v-autocomplete :label="$t('imageSize')" variant="none" density="compact" disabled v-model="LLmsModel.resolution" value="1024x1024" class="model-input-control" readonly>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </transition>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <!-- Header with info and action buttons -->
                    <div style="display: flex; align-items: center; gap: 12px">
                      <img src="@/assets/lucide_pen-line.svg" alt="img" width="20" height="20" />
                      <span style="font-weight: 600; color: #171717; font-size: 16px">{{ $t("_setSystemPrompt") }}</span>
                    </div>
                    <v-card variant="none" class="prompt-editor-card">
                      <v-card-text class="">
                        <v-textarea
                          id="PromptTemplate"
                          :label="''"
                          variant="plain"
                          counter
                          auto-grow
                          rows="8"
                          v-model="LLmsModel.promptTemplate"
                          :rules="[validatePrompt(LLmsModel.promptTemplate)]"
                          required
                          :placeholder="$t('enterSystemPromptHere')"
                          class="prompt-textarea"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="4">
                    <v-card class="prompt-templates-card h-100">
                      <v-card-title class="py-3 px-4 d-flex align-center">
                        <span class="text-subtitle-2" style="font-weight: 700; color: #171717; font-size: 14px">{{ $t("PromptTemplate") }}</span>
                        <div class="d-flex align-center ml-2">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="20" height="20" />
                            </template>
                            <span>{{ $t("_tipSelectPromptTemplate") }}</span>
                          </v-tooltip>
                        </div>
                      </v-card-title>

                      <div class="px-3 pt-3">
                        <v-autocomplete
                          class="select-prompt mb-3 rounded-input padding-input"
                          id="groupprompttemplate-autocomplete-modelmanagement"
                          :items="DDGroupPromptTemplate"
                          item-title="name"
                          :placeholder="$t('selectPromptTemplate')"
                          item-value="id"
                          density="compact"
                          clearable
                          variant="none"
                          v-model="groupPromptTemplate"
                          hide-details
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'groupprompttemplate-gptmodeldetail-option-' + index" :value="item.raw.name">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>

                      <v-list class="prompt-template-list" density="compact">
                        <div v-if="filteredPromptTemplates.length === 0" class="pa-4 text-center text-grey-darken-1 h-100 mt-9">
                          <Icon class="d-block mx-auto mb-2" icon="fluent:book-template-20-filled" style="font-size: 22px; color: #8d8d8d" />
                          <span>{{ $t("noTemplatesAvailable") }}</span>
                        </div>

                        <template v-else>
                          <v-list-item v-for="(item, i) in filteredPromptTemplates.slice(0, 10)" :key="i" @click="SetSelectPromptTemplate(item)" :ripple="true" class="template-list-item">
                            <template v-slot:prepend>
                              <v-icon icon="mdi-text-box-outline" size="small"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span id="list-nameprompttemplate-modelmanagement" class="text-body-2">{{ item.name }}</span>
                            </template>
                            <template v-slot:append>
                              <v-icon size="small" color="primary">mdi-plus-circle-outline</v-icon>
                            </template>
                          </v-list-item>

                          <div v-if="filteredPromptTemplates.length > 10" class="d-flex justify-center py-2">
                            <v-btn
                              id="button-showallprompttemplate-modelmanagement"
                              variant="text"
                              color="primary"
                              size="small"
                              density="comfortable"
                              @click="showAll"
                              prepend-icon="mdi-format-list-bulleted"
                            >
                              {{ $t('_ShowAll') }} ({{ filteredPromptTemplates.length }})
                            </v-btn>
                          </div>
                        </template>
                      </v-list>
                    </v-card>
                    <!-- Context menu for prompt templates -->
                    <v-menu v-model="showMenu" :activator="{ x, y }" location="bottom">
                      <v-card min-width="250" elevation="3">
                        <v-list density="compact" class="py-0">
                          <v-list-subheader class="d-flex bg-grey-lighten-4 py-2">
                            <v-icon icon="mdi-text-box-plus-outline" class="me-2" size="small"></v-icon>
                            {{ $t("insertTemplate") }}
                          </v-list-subheader>
                          <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                          <v-list-item
                            v-for="(item, index) in filteredPromptTemplates"
                            :key="index"
                            @click="
                              SetSelectPromptTemplate(item);
                              showMenu = false;
                            "
                            :value="item.name"
                            class="template-list-item"
                          >
                            <template v-slot:prepend>
                              <v-icon size="small" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span>{{ item.name }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </v-col>

                  <!-- Dialog for showing all templates -->
                  <v-dialog v-model="dialogShowAll" max-width="550" scrollable>
                    <v-card>
                      <v-card-title class="bg-primary text-white d-flex align-center">
                        <v-icon icon="mdi-text-box-multiple-outline" class="me-2"></v-icon>
                        {{ $t("promptTemplates") }}
                      </v-card-title>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-text style="max-height: 500px" class="pt-4">
                        <v-text-field
                          v-model="templateSearchQuery"
                          :label="$t('searchTemplates')"
                          prepend-inner-icon="mdi-magnify"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="mb-3"
                          clearable
                        ></v-text-field>

                        <v-list density="compact" class="template-list-all pa-0">
                          <v-list-item v-for="(item, i) in searchedTemplates" :key="i" @click="SetSelectPromptTemplate(item)" class="template-list-item" :ripple="true">
                            <template v-slot:prepend>
                              <v-icon size="small" color="primary" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span :id="'list-nameprompttemplateall-modelmanagement-' + i">{{ item.name }}</span>
                            </template>
                            <template v-slot:subtitle>
                              <span class="text-caption text-truncate">{{ truncatePrompt(item.prompt) }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-actions class="pa-3 bg-grey-lighten-4">
                        <v-spacer></v-spacer>
                        <v-btn id="button-close-popupshowall-modelmanagement" color="primary" variant="text" @click="dialogShowAll = false">
                          {{ $t('close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>
              </v-container>
            </v-row>

            <!-- Knowledge -->
            <v-card class="knowledge-card mt-4">
              <h3 style="color: #c32e0e; font-weight: 600">{{ $t("knowledge") }}</h3>
              <div class="d-flex align-center justify-start mt-2 mb-2" style="gap: 8px">
                <img src="@/assets/f7_doc-text-fill.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">{{ $t("documents") }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t("documentName") }}</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    id="documentname-autocomplete-modelmanagement"
                    :placeholder="$t('documentName')"
                    clearable
                    :items="DDVector"
                    item-title="name"
                    item-value="name"
                    density="compact"
                    chips
                    deletable-chips
                    multiple
                    variant="none"
                    v-model="LLmsModel.vectordbName"
                    :rules="[rules.required]"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'documentname-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon id="infovectorDBname-modelmanagement" size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoVectorDBName') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete
                    class="model-input-control mt-8"
                    id="text-replacement-modelmanagement"
                    :placeholder="$t('textReplacement')"
                    clearable
                    :items="DDGroupReplace"
                    item-title="name"
                    density="compact"
                    chips
                    deletable-chips
                    item-value="id"
                    multiple
                    variant="none"
                    v-model="LLmsModel.groupReplaceID"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'textreplacement-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon id="InfoGroupReplaceText-modelmanegement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoGroupReplaceText') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t("topNChunk") }}</span>
                  <v-text-field
                    class="model-input-control mt-2"
                    id="top-n-chunks-field-modelmanagement"
                    :placeholder="$t('topNChunks')"
                    density="compact"
                    :disabled="!LLmsModel.vectordbName?.length"
                    v-model="LLmsModel.topVDB"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    :rules="[checkValidate()]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon id="infotopVDB-modelmanagement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoTopVDB') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- Knowledge Graph (S13-P1) -->
              <div class="d-flex align-center justify-start mb-2 mt-4" style="gap: 8px">
                <v-icon size="20" color="#C32E0E">mdi-graph-outline</v-icon>
                <span style="font-weight: 600; font-size: 16px; color: #171717">{{ $t('graphRagModelSection') }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    class="model-input-control"
                    id="knowledgegraph-autocomplete-modelmanagement"
                    data-testid="kg-model-graphs"
                    :placeholder="$t('graphRagModelSection')"
                    :loading="loadingKnowledgeGraphs"
                    :no-data-text="$t('graphRagModelNoGraphs')"
                    clearable
                    :items="DDKnowledgeGraphs"
                    item-title="name"
                    item-value="graphKey"
                    density="compact"
                    chips
                    deletable-chips
                    multiple
                    variant="none"
                    v-model="LLmsModel.knowledgeGraphKeys"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'knowledgegraph-gptmodeldetail-option-' + index" :value="item.raw.graphKey">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                        <template v-slot:subtitle>
                          <span>{{ item.raw.graphKey }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon id="infoknowledgegraph-modelmanagement" size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('graphRagModelInfo') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>

              <v-expansion-panels v-if="hasKnowledgeGraphSelected" class="mt-2 mb-4" variant="accordion" data-testid="kg-model-advanced">
                <v-expansion-panel>
                  <v-expansion-panel-title>{{ $t('graphRagModelAdvanced') }}</v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <div class="text-caption text-medium-emphasis mb-3">{{ $t('graphRagModelAdvancedHint') }}</div>

                    <div class="d-flex align-center mb-1" style="gap: 8px">
                      <v-switch
                        class="memory-switch"
                        id="kg-usecitation-modelmanagement"
                        data-testid="kg-model-usecitation"
                        density="compact"
                        hide-details
                        color="#C32E0E"
                        v-model="LLmsModel.kgRetrievalConfig.useCitationContext"
                        :label="$t('graphRagModelUseCitation')"
                      ></v-switch>
                    </div>
                    <div class="text-caption text-medium-emphasis mb-4">{{ $t('graphRagModelUseCitationHint') }}</div>

                    <v-row>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelMaxHops') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-maxhops-modelmanagement"
                          data-testid="kg-model-maxhops"
                          :placeholder="$t('graphRagModelMaxHops')"
                          density="compact"
                          variant="none"
                          type="number"
                          v-model="LLmsModel.kgRetrievalConfig.maxHops"
                          :rules="[kgRangeRule('graphRagModelMaxHops', 1, 10)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelMaxHopsHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelSearchMode') }}</span>
                        <v-select
                          class="model-input-control mt-2"
                          id="kg-searchmode-modelmanagement"
                          data-testid="kg-model-searchmode"
                          :placeholder="$t('graphRagModelSearchMode')"
                          density="compact"
                          variant="none"
                          :items="kgSearchModes"
                          v-model="LLmsModel.kgRetrievalConfig.searchMode"
                        ></v-select>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelSearchModeHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelFuzzyThreshold') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-fuzzythreshold-modelmanagement"
                          data-testid="kg-model-fuzzythreshold"
                          :placeholder="$t('graphRagModelFuzzyThreshold')"
                          density="compact"
                          variant="none"
                          type="number"
                          step="0.01"
                          v-model="LLmsModel.kgRetrievalConfig.fuzzyThreshold"
                          :rules="[kgRangeRule('graphRagModelFuzzyThreshold', 0, 100)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelFuzzyThresholdHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelSemanticThreshold') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-semanticthreshold-modelmanagement"
                          data-testid="kg-model-semanticthreshold"
                          :placeholder="$t('graphRagModelSemanticThreshold')"
                          density="compact"
                          variant="none"
                          type="number"
                          step="0.01"
                          v-model="LLmsModel.kgRetrievalConfig.semanticThreshold"
                          :rules="[kgRangeRule('graphRagModelSemanticThreshold', 0, 1)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelSemanticThresholdHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelMaxContextNodes') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-maxcontextnodes-modelmanagement"
                          data-testid="kg-model-maxcontextnodes"
                          :placeholder="$t('graphRagModelMaxContextNodes')"
                          density="compact"
                          variant="none"
                          type="number"
                          v-model="LLmsModel.kgRetrievalConfig.maxContextNodes"
                          :rules="[kgRangeRule('graphRagModelMaxContextNodes', 1, 200)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelMaxContextNodesHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelMaxContextEdges') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-maxcontextedges-modelmanagement"
                          data-testid="kg-model-maxcontextedges"
                          :placeholder="$t('graphRagModelMaxContextEdges')"
                          density="compact"
                          variant="none"
                          type="number"
                          v-model="LLmsModel.kgRetrievalConfig.maxContextEdges"
                          :rules="[kgRangeRule('graphRagModelMaxContextEdges', 1, 400)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelMaxContextEdgesHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelBaselineTopK') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-baselinetopk-modelmanagement"
                          data-testid="kg-model-baselinetopk"
                          :placeholder="$t('graphRagModelBaselineTopK')"
                          density="compact"
                          variant="none"
                          type="number"
                          v-model="LLmsModel.kgRetrievalConfig.baselineTopK"
                          :rules="[kgRangeRule('graphRagModelBaselineTopK', 1, 100)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelBaselineTopKHint') }}</div>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t('graphRagModelBaselineMinSim') }}</span>
                        <v-text-field
                          class="model-input-control mt-2"
                          id="kg-baselineminsim-modelmanagement"
                          data-testid="kg-model-baselineminsim"
                          :placeholder="$t('graphRagModelBaselineMinSim')"
                          density="compact"
                          variant="none"
                          type="number"
                          step="0.01"
                          v-model="LLmsModel.kgRetrievalConfig.baselineMinSimilarity"
                          :rules="[kgRangeRule('graphRagModelBaselineMinSim', 0, 1)]"
                        ></v-text-field>
                        <div class="text-caption text-medium-emphasis">{{ $t('graphRagModelBaselineMinSimHint') }}</div>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>

              <!-- Database -->
              <div class="d-flex align-center justify-start mb-2 mt-4" style="gap: 8px">
                <img src="@/assets/solar_database-bold.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">{{ $t("database") }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t("tableName") }}</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    id="tablename-autocomplete-modelmanagement"
                    :placeholder="$t('tableName')"
                    clearable
                    :items="listDataIntegration"
                    item-title="dataName"
                    item-value="id"
                    density="compact"
                    variant="none"
                    v-model="LLmsModel.DataIntegrationID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'tablename-gptmodeldetail-option-' + index" :value="item.raw.dataName">
                        <template v-slot:title>
                          <span>{{ item.raw.dataName }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoDataIntegration') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-autocomplete
                    class="model-input-control mt-8"
                    id="sqlextractionmodel-autocomplete-modelmanagement"
                    clearable
                    :placeholder="$t('sqlExtractionModel')"
                    :items="listSqlExtract"
                    item-title="name"
                    item-value="modelDisplayID"
                    density="compact"
                    variant="none"
                    v-model="LLmsModel.SqlModelID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'sqlextractionmodel-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="2">
                  <button type="button" id="button-customize-nodata-modelmanagement" class="no-data-message-button mt-8" @click="openPromptSqlNoDataDialog">
                    <img src="@/assets/plus.svg" alt="img" width="15" height="15" />
                    <span style="font-size: 13px; color: #c32e0e">{{ $t("addPromptForNoData") }}</span>
                    <!-- {{promptSqlNoDataButtonText}} -->
                  </button>
                </v-col>

                <v-col cols="12" sm="12" md="2">
                  <button type="button" class="circle-button-no-data mt-10">
                    <img src="@/assets/cross-circle.svg" alt="img" width="15" height="15" />
                    <span style="color: #ffffff; font-size: 10px">{{ $t("noData") }}</span>
                  </button>
                </v-col>
              </v-row>

              <v-dialog v-model="promptSqlNoDataDialog" max-width="600" persistent>
                <v-card class="no-data-dialog-card" elevation="4">
                  <v-card-title class="d-flex align-center justify-space-between py-4 px-5">
                    <span class="text-h6 font-weight-bold">{{ $t("customizeNoDataMessage") }}</span>
                    <v-btn id="button-close-nodata-dialog-modelmanagement" variant="text" icon="mdi-close" color="grey-darken-1" @click="cancelPromptSqlNoDataDialog"></v-btn>
                  </v-card-title>
                  <v-card-text class="px-5 pt-0 pb-2">
                    <v-textarea
                      id="promptsqlnodata-textarea-modelmanagement"
                      variant="outlined"
                      rows="7"
                      v-model="promptSqlNoDataDraft"
                      :placeholder="$t('_enterNoDataText')"
                      auto-grow
                    ></v-textarea>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-4 px-5 justify-end">
                    <v-btn
                      id="button-cancel-nodata-dialog-modelmanagement"
                      class="dialog-close-btn mr-3"
                      variant="text"
                      color="grey-darken-1"
                      prepend-icon="mdi-close"
                      @click="cancelPromptSqlNoDataDialog"
                      >{{ $t("close") }}</v-btn
                    >
                    <v-btn id="button-save-nodata-dialog-modelmanagement" class="dialog-save-btn" color="white" variant="flat" @click="savePromptSqlNoData">
                      <v-img :src="newSaveImg" alt="Customize No Data Dialog" class="image-icon-style"></v-img>
                      {{ $t("save") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <div class="d-flex align-center justify-start mb-2 mt-4" style="gap: 8px">
                <img src="@/assets/product-bold.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">{{ $t("products") }}</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">{{ $t("productGroupName") }}</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    :placeholder="$t('productGroupName')"
                    clearable
                    :items="DDProductGroup"
                    item-title="name"
                    density="compact"
                    chips
                    deletable-chips
                    item-value="id"
                    multiple
                    variant="none"
                    v-model="LLmsModel.productGroupID"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'productgroupname-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoGroupReplaceText') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <span>{{ $t("topNChunk") }}</span>
                  <v-text-field
                    class="model-input-control mt-2"
                    id="product-top-n-chunks-field-modelmanagement"
                    :placeholder="$t('topNChunks')"
                    density="compact"
                    :disabled="!LLmsModel.productGroupID?.length"
                    v-model="LLmsModel.productTopVDB"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    :rules="[checkProductValidate()]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoTopVDB') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <!-- Workflow -->

            <v-row class="mt-4" v-if="!workflowPanelOpen" @click="workflowPanelOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/mdi_workflow.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">{{ $t("workflow") }}</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="workflowPanelOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex flex-column">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/mdi_workflow.svg" alt="img" width="20" height="20" />
                    <span class="header">{{ $t("workflow") }}</span>
                  </div>
                  <div>
                    <span class="workflow-header__subtitle" v-show="workflowPanelOpen">{{ $t("_configureWorkflow") }}</span>
                  </div>
                </div>
                <div class="mt-2 d-flex flex-row align-end">
                  <div class="chipdiv">
                    <div class="d-flex flex-column align-end">
                      <v-chip :class="{ 'flow-selected': LLmsModel.flowGroupID, 'flow-not-selected': !LLmsModel.flowGroupID }" size="small">
                        <v-icon :color="LLmsModel.flowGroupID ? '#04B439' : 'white'" class="mr-2" size="16">
                          {{ LLmsModel.flowGroupID ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        {{ LLmsModel.flowGroupID ? $t('flowConnected') : $t('noFlowSelected') }}
                      </v-chip>
                      <span class="mt-2 chipspan">{{ $t("_selectFlowEnable") }}</span>
                    </div>
                  </div>

                  <button type="button" @click="workflowPanelOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <v-row class="mt-4">
                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/code-branch-solid.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">{{ $t("flowConfiguration") }}</span>
                  </div>
                  <v-select
                    class="model-input-control mt-2"
                    id="flow-dropdown-modelmanagement"
                    v-model="LLmsModel.flowGroupID"
                    :items="flowDropdown"
                    item-title="name"
                    item-value="flowGroupID"
                    density="compact"
                    variant="none"
                    :placeholder="$t('selectFlow')"
                    clearable
                  >
                    <template v-slot:selection="{ item }">
                      <div>
                        <span class="font-weight-medium">{{ item.raw.name }}</span>
                      </div>
                    </template>

                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" class="flow-list-item" :id="'flow-gptmodeldetail-option-' + index" :value="item.raw.flowGroupID">
                        <template v-slot:prepend>
                          <v-avatar size="32" color="primary" variant="tonal">
                            <v-icon size="16" color="primary">mdi-chart-timeline-variant-shimmer</v-icon>
                          </v-avatar>
                        </template>
                        <template v-slot:title>
                          <span class="font-weight-medium">{{ item.raw.name }}</span>
                        </template>
                        <template v-slot:subtitle>
                          <span class="text-caption text-grey-darken-1"> Flow ID: {{ item.raw.flowGroupID }} </span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/ri_focus-3-line.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">{{ $t("intentDetection") }}</span>
                  </div>
                  <v-autocomplete
                    id="groupintent-autocomplete-modelmanagement"
                    :placeholder="$t('selectIntent')"
                    clearable
                    :items="listDDIntentGroup"
                    item-title="name"
                    item-value="id"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    v-model="LLmsModel.IntentGroupID"
                    :disabled="intentAutocompleteDisabled"
                    :hint="intentHelperText"
                    :persistent-hint="intentAutocompleteDisabled"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'groupintent-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoDataIntegration') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4" v-if="LLmsModel.typeLLM == 0">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/majesticons_shield-line.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">{{ $t("guardRail") }}</span>
                  </div>
                  <v-autocomplete
                    id="guardrailmodel-autocomplete-modelmanagement"
                    :placeholder="$t('selectGuardRail')"
                    clearable
                    :items="listGuardRailModel"
                    item-title="name"
                    item-value="modelDisplayID"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    v-model="LLmsModel.guardRailModelID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'guardrail-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card>

            <!-- Model Setting -->
            <v-row class="mt-4" v-if="!modelSettingOpen" @click="modelSettingOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/config.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">{{ $t("modelSetting") }}</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="modelSettingOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center justify-start gap-2">
                  <img src="@/assets/config.svg" alt="img" width="20" height="20" />
                  <span class="header">{{ $t("modelSetting") }}</span>
                </div>
                <div class="mt-2">
                  <button type="button" @click="modelSettingOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <div>
                <v-row class="memory-card mt-4 mx-1">
                  <v-col cols="8" style="height: 160px">
                    <div class="memory-card__short">
                      <div class="memory-section-header d-flex align-center">
                        <img src="@/assets/5a410419-c731-4277-877c-bd68c49236af.svg" alt="img" width="24" height="24" />
                        <h4 class="memory-title">{{ $t("shortTermMemory") }}</h4>
                      </div>
                      <v-row class="memory-input-row" dense>
                        <v-col cols="4" class="col-label-input">
                          <span>{{ $t("turn") }}</span>
                          <v-text-field
                            id="turn-memory-modelmanagement"
                            :placeholder="$t('turn')"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            v-model="LLmsModel.historyCount"
                            class="rounded-input"
                            @keypress="isNumberpositive($event)"
                            min="0"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoTurn') }} </span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>{{ $t("characterTurn") }}</span>
                          <v-text-field
                            id="short-term-memory-modelmanagement"
                            :placeholder="$t('characterTurn')"
                            clearable
                            density="comfortable"
                            class="rounded-input"
                            variant="outlined"
                            v-model="LLmsModel.Len_ShortMemory"
                            @keypress="numericKey"
                            min="1"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoShortMemory') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>{{ $t("durationMinute") }}</span>
                          <v-text-field
                            id="duration-memory-modelmanagement"
                            :placeholder="$t('durationMinute')"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            class="rounded-input"
                            v-model="LLmsModel.historyMinute"
                            @keypress="isNumber($event)"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: 0px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoMinute') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="4" style="height: 160px; display: flex; align-items: flex-start">
                    <v-divider vertical class="memory-card__divider ml-3"></v-divider>

                    <div class="memory-card__long" style="margin-left: 20px">
                      <div class="memory-section-header" style="display: flex; flex-direction: column; align-items: flex-start">
                        <div class="memory-icon">
                          <img src="@/assets/1b437834-ee3e-445e-b215-0fe31a31ccde.svg" alt="img" width="24" height="24" />
                          <h4 class="memory-title">{{ $t("longTermMemory") }}</h4>
                        </div>
                        <div style="margin-top: 20px; padding-left: 10px; display: flex; justify-content: flex-start; flex-direction: column">
                          <p class="memory-status mb-0">{{ longTermMemoryStatus }}</p>

                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-switch v-bind="props" id="checkbox-longterm-memory-modelmanagement" class="memory-switch" v-model="LLmsModel.IsLongTerm_Memory"> </v-switch>
                            </template>
                            <span>{{ $t("_tipLongTermMemory") }}</span>
                          </v-tooltip>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Enable Mutiple-Turn Input -->
                <v-row class="multi-turn-section align-center pl-1" dense>
                  <v-col cols="12" sm="12" md="3">
                    <div class="multi-turn-toggle">
                      <span style="font-weight: 600">{{ $t('_InfoMultiTurnInput') }}</span>
                      <v-tooltip location="top" max-width="330px">
                        <template v-slot:activator="{ props }">
                          <v-switch v-bind="props" id="enablemulti-turninput-checkbox-modelmanagement" class="memory-switch mt-6" v-model="LLmsModel.IsChainMassage"> </v-switch>
                        </template>
                        <span>{{ $t("_tipMultiTurnInput") }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" style="margin-top: -28px">
                    <div>
                      <span>{{ $t("sequence") }}</span>
                      <v-text-field
                        class="model-input-control mt-2"
                        id="sequence-field-modelmanagement"
                        :placeholder="$t('sequence')"
                        density="comfortable"
                        :disabled="!LLmsModel.IsChainMassage"
                        v-model="LLmsModel.LenChainMassage"
                        variant="none"
                        @keypress="isNumberpositive($event)"
                        :rules="[checkValidate()]"
                      >
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t('_InfoSequence') }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" style="margin-top: -28px">
                    <div>
                      <span>{{ $t("durationSeconds") }}</span>
                      <v-text-field
                        class="model-input-control mt-2"
                        id="duration-field-modelmanagement"
                        :placeholder="$t('durationSeconds')"
                        density="comfortable"
                        :disabled="!LLmsModel.IsChainMassage"
                        v-model="LLmsModel.TimeSecondChainMassage"
                        variant="none"
                        @keypress="isNumberpositive($event)"
                        :rules="[checkValidate()]"
                      >
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t('_InfoTimeSeconds') }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>
                </v-row>

                <!-- Parameters -->
                <v-row id="parameters-section-modelmanagement" style="margin-top: -20px; padding-left: 3px">
                  <v-col cols="12">
                    <span style="font-weight: 600; font-size: 18px">{{ $t("Parameters") }}</span>
                  </v-col>
                  <v-col cols="12" class="py-0" v-if="modelProbe.status !== 'idle'">
                    <div class="model-probe-status" :class="'model-probe-status--' + modelProbe.status">
                      <v-progress-circular v-if="modelProbe.status === 'running'" indeterminate size="14" width="2" class="mr-2"></v-progress-circular>
                      <span>{{ modelProbeMessage }}</span>
                      <button
                        v-if="modelProbe.suggestion"
                        id="apply-probe-suggestion-modelmanagement"
                        type="button"
                        class="model-probe-apply"
                        @click="applyProbeSuggestion"
                      >{{ $t('_probeUseSuggested') }}</button>
                    </div>
                  </v-col>
                  <!-- ถ้าทดสอบจริงแล้วไม่ผ่าน กล่องผลทดสอบด้านบนบอกเรื่องเดียวกันอยู่แล้ว ไม่ต้องแสดงซ้ำ -->
                  <v-col cols="12" class="py-0" v-if="samplingRuleViolations.length > 0 && modelProbe.status !== 'invalid-sampling'">
                    <div class="model-probe-status model-probe-status--invalid-sampling">
                      <span>{{ samplingRuleMessage }}</span>
                      <button
                        id="apply-sampling-rule-modelmanagement"
                        type="button"
                        class="model-probe-apply"
                        @click="applySamplingRule"
                      >{{ $t('_probeUseSuggested') }}</button>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <div :class="{ 'model-field-highlight': parametersHighlight && !!parameterFieldError('temperature') }">
                    <span>{{ $t("temperature") }} (0-1)</span>
                    <v-text-field
                      id="temperature-field-modelmanagement"
                      :placeholder="$t('temperature')"
                      class="model-input-control"
                      v-model="LLmsModel.temperature"
                      density="compact"
                      @keypress="isNumber($event)"
                      variant="none"
                      :rules="[validateInput0_1(LLmsModel.temperature)]"
                      :error="!!parameterFieldError('temperature')"
                      :error-messages="parameterFieldError('temperature')"
                      @update:model-value="clearParameterError('temperature')"
                      required
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoTemperature') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    <div v-if="parameterFieldError('temperature')" class="model-field-error">{{ parameterFieldError('temperature') }}</div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <div :class="{ 'model-field-highlight': parametersHighlight && !!parameterFieldError('topP') }">
                    <span>{{ $t("topP") }} (0-1)</span>
                    <v-text-field
                      id="topP-field-modelmanagement"
                      :placeholder="$t('topP')"
                      class="model-input-control"
                      v-model="LLmsModel.topP"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      :rules="[validateTopPInput(LLmsModel.topP)]"
                      :error="!!parameterFieldError('topP')"
                      :error-messages="parameterFieldError('topP')"
                      @update:model-value="clearParameterError('topP')"
                      required
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoTopP') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    <div v-if="parameterFieldError('topP')" class="model-field-error">{{ parameterFieldError('topP') }}</div>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span>{{ $t("frequencyPenalty") }} (0-2)</span>
                    <v-text-field
                      id="frequency-penalty-modelmanagement"
                      :placeholder="$t('frequencyPenalty')"
                      class="model-input-control"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      v-model="LLmsModel.frequencyPenalty"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :rules="[validateInput0_2(LLmsModel.frequencyPenalty)]"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoFrequencyPenalty') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span>{{ $t("presencePenalty") }} (0-2)</span>
                    <v-text-field
                      id="presence-penalty-modelmanagement"
                      :placeholder="$t('presencePenalty')"
                      class="model-input-control"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      v-model="LLmsModel.presencePenalty"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :rules="[validateInput0_2(LLmsModel.presencePenalty)]"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoPresencePenalty') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span>{{ $t("maxTokensResponse") }}</span>
                    <v-text-field
                      id="max-tokens-response-modelmanagement"
                      :placeholder="$t('maxTokensResponse')"
                      class="model-input-control"
                      variant="none"
                      density="compact"
                      @keypress="isNumberpositive($event)"
                      v-model="LLmsModel.maxTokens"
                      :error="error.maxTokens.error"
                      :error-messages="error.maxTokens.message"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoMaxToken') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <span>{{ $t("timeoutResponse") }} (1-3600)</span>
                    <v-text-field
                      id="llm-timeout-add-modelmanagement"
                      :placeholder="$t('timeoutResponseSeconds')"
                      class="model-input-control"
                      variant="none"
                      density="compact"
                      type="number"
                      step="0.01"
                      min="1"
                      max="3600"
                      @keypress="isPositiveDecimal($event)"
                      v-model.number="LLmsModel.llmTimeout"
                      clearable
                      :hint="$t('_hintTimeoutShort')"
                      persistent-hint
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="3">
                    <span>{{ $t("stopSequence") }}</span>
                    <v-text-field id="stop-sequence-modelmanagement" :placeholder="$t('stopSequence')" class="model-input-control" v-model="LLmsModel.stop" variant="none" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>
                            {{ $t('_InfoStop') }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="3">
                    <span>{{ $t("gender") }}</span>
                    <v-select
                      id="gender-autocomplete-modelmanagement"
                      v-model="LLmsModel.gender"
                      :items="DDGender"
                      class="model-input-control"
                      item-title="name"
                      item-value="id"
                      :placeholder="$t('gender')"
                      density="compact"
                      variant="none"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card>

            <!-- Chat Setting -->
            <v-row class="mt-4" v-if="!chatSettingOpen" @click="chatSettingOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/fluent_settings-chat-16-filled.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">{{ $t("chatSetting") }}</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="chatSettingOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center justify-start gap-2">
                  <img src="@/assets/fluent_settings-chat-16-filled.svg" alt="img" width="20" height="20" />
                  <span class="header">{{ $t("chatSetting") }}</span>
                </div>
                <div class="mt-2">
                  <button type="button" @click="chatSettingOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <!-- Stream Response -->
              <v-row class="mt-4">
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column mt-1"
                    :class="{ 'option-active': LLmsModel.isStream }"
                    :style="LLmsModel.isStream ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="78px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">{{ $t("streamResponse") }}</span>
                          <v-tooltip top max-width="320">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>{{ $t("_tipStreamResponse") }}</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1" v-if="LLmsModel.isStream">{{ $t("_streamOn") }}</div>
                        <div class="grey--text text-caption mt-1" v-else>{{ $t("_streamOff") }}</div>
                      </div>
                      <v-switch id="switch-stream-ModelManagement" v-model="LLmsModel.isStream" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex align-center gap-2">
                    <span :style="LLmsModel.isStream ? '' : 'color:rgba(55, 65, 81, 0.6);'">{{ $t("typingDelayMs") }}</span>
                    <v-tooltip location="top" max-width="320">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                      </template>
                      <span>{{ $t("_tipTypingDelay") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="typingspeed-field-modelmanagement"
                    v-model.number="LLmsModel.typingSpeed"
                    class="model-input-control mt-2"
                    :class="LLmsModel.isStream ? 'input--enabled' : 'input--disabled'"
                    :readonly="!LLmsModel.isStream"
                    :placeholder="$t('typingSpeed')"
                    type="number"
                    min="0"
                    density="compact"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex align-center gap-2">
                    <span>{{ $t("maxInputLength") }}</span>
                    <v-tooltip location="top" max-width="320">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                      </template>
                      <span>{{ $t("_tipMaxInputLength") }}</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="maxinputlength-field-modelmanagement"
                    v-model.number="LLmsModel.maximumChatInput"
                    :placeholder="$t('maxInputLength')"
                    type="number"
                    min="0"
                    :max="maxChatInputLimit"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    :rules="[rules.required]"
                    @keypress="maxNumberpositive($event)"
                    @blur="clampMaximumChatInput()"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Collect Feedback -->
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column"
                    :class="{ 'option-active': LLmsModel.isFeedback }"
                    :style="LLmsModel.isFeedback ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="80px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">{{ $t("collectFeedback") }}</span>
                          <v-tooltip top max-width="420">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>{{ $t("_tipCollectFeedback") }}</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1">{{ $t("_allowUsersRate") }}</div>
                      </div>
                      <v-switch id="switch-feedback-ModelManagement" v-model="LLmsModel.isFeedback" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <!--  Image Upload Settings -->
                <v-col cols="12" sm="12" md="8">
                  <v-row class="mr-1" :style="LLmsModel.isAllowImage ? 'background: #FFF2F2; border-radius: 10px; max-height: 80px; margin-top:0px; margin-left:0px' : ''">
                    <v-col cols="6" :style="LLmsModel.isAllowImage ? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="option-card d-flex flex-column"
                            :class="{
                              'on-hover': hover,
                              'option-active': LLmsModel.isAllowImage && showFileUpload,
                            }"
                            flat
                            height="100%"
                            :style="LLmsModel.isAllowImage ? 'background: #FFF2F2;' : ''"
                            :min-height="LLmsModel.isAllowImage && showFileUpload ? '80px' : '80px'"
                          >
                            <div class="d-flex justify-space-between align-center">
                              <!-- Left Side (Label + Info) -->
                              <div class="option-header">
                                <div class="d-flex align-center gap-2">
                                  <span style="font-weight: 600">{{ $t("imageUpload") }}</span>
                                  <v-tooltip location="top" max-width="380">
                                    <template v-slot:activator="{ props }">
                                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                    </template>
                                    <span>{{ $t("_tipImageUpload") }}</span>
                                  </v-tooltip>
                                </div>
                                <p class="grey--text text-caption mt-1">{{ $t("_allowUsersUploadImages") }}</p>
                              </div>

                              <!-- Switch -->
                              <v-switch id="fileupload-checkbox-modelmanagement" v-model="LLmsModel.isAllowImage" class="memory-switch" color="primary" :disabled="!modelSupportsFileUpload"></v-switch>
                            </div>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-col>

                    <v-col cols="6" :style="LLmsModel.isAllowImage ? 'padding-top: 0px;' : 'padding-top: 12px;'">
                      <v-card
                        class="d-flex flex-column pt-3"
                        :class="{ 'option-active': LLmsModel.isAllowImage }"
                        :style="LLmsModel.isAllowImage ? 'background: #FFF2F2;' : ''"
                        flat
                        height="100%"
                        min-height="80px"
                      >
                        <div v-if="LLmsModel.isAllowImage" class="additional-content d-flex align-end">
                          <v-text-field
                            v-if="LLmsModel.isAllowImage && showFileUpload"
                            id="fileuploadlimit-field-modelmanagement"
                            :placeholder="$t('maximumFileSize')"
                            @keypress="validateNumber($event)"
                            @paste="validateNumber($event)"
                            v-model.number="LLmsModel.fileUploadLimit"
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                            class="rounded-input padding-input input--enabled"
                            :hint="$t('_hintRecommendedFileSize')"
                            persistent-hint
                            :rules="[rules.required]"
                            :disabled="!modelSupportsFileUpload"
                          >
                            <template v-slot:append-inner>
                              <v-chip size="small" color="blue-grey lighten-1" text-color="white" class="file-size-chip"> KB </v-chip>
                            </template>

                            <template v-slot:append>
                              <v-tooltip location="top" max-width="300">
                                <template v-slot:activator="{ props }">
                                  <v-icon small color="grey-darken-1" v-bind="props" class="info-icon-enhanced"> mdi-information-outline </v-icon>
                                </template>
                                <span>{{ $t('_InfoMaximumFileUpload') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- LLM Selection -->
              <v-row class="mr-1">
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column"
                    :class="{ 'option-active': LLmsModel.isAllowLLMChange }"
                    :style="LLmsModel.isAllowLLMChange ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="80px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">{{ $t("llmSelection") }}</span>
                          <v-tooltip top max-width="330">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>{{ $t("_tipLlmSelection") }}</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1">{{ $t("_allowModelSwitching") }}</div>
                      </div>
                      <v-switch id="llm-selection-switch-modelmanagement" v-model="LLmsModel.isAllowLLMChange" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <!-- Time Settings -->
                <v-col cols="8">
                  <v-row :style="LLmsModel.enableTime ? 'background: #FFF2F2; border-radius: 10px; max-height: 80px; margin-top:0px; margin-left:0px' : ''">
                    <v-col cols="6" :style="LLmsModel.enableTime ? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="option-card d-flex flex-column"
                            :class="{
                              'on-hover': hover,
                              'option-active': LLmsModel.enableTime,
                            }"
                            :style="LLmsModel.enableTime ? 'background: #FFF2F2;' : ''"
                            flat
                            height="100%"
                            min-height="80px"
                          >
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center gap-2">
                                  <span style="font-weight: 600">{{ $t("timeContext") }}</span>
                                  <v-tooltip location="top" max-width="400">
                                    <template v-slot:activator="{ props }">
                                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                    </template>
                                    <span>{{ $t("_tipTimeContext") }}</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">{{ $t("_enableTimeAwareness") }}</div>
                              </div>
                              <v-switch id="Enabletime-modelmanagement" v-model="LLmsModel.enableTime" class="memory-switch"></v-switch>
                            </div>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-col>
                    <v-col cols="6" :style="LLmsModel.enableTime ? 'padding-top: 0px;' : 'padding-top: 12px;'">
                      <v-card
                        class="d-flex flex-column"
                        :class="{ 'option-active': LLmsModel.enableTime }"
                        :style="LLmsModel.enableTime ? 'background: #FFF2F2;' : ''"
                        flat
                        height="100%"
                        min-height="80px"
                      >
                        <div v-if="LLmsModel.enableTime" style="margin-top: 12px" class="additional-content">
                          <v-select
                            id="timezone-modelmanagement"
                            v-model="LLmsModel.timeZone"
                            :items="DDTimeZone"
                            item-title="name"
                            item-value="value"
                            :placeholder="$t('timeZone')"
                            density="compact"
                            variant="none"
                            hide-details="auto"
                            background-color="white"
                            class="model-input-control"
                          >
                            <template v-slot:selection="{ item }">
                              <div style="padding: 7px" class="timezone-selection d-flex align-center">
                                <v-icon small color="primary" class="mr-2">mdi-map-marker</v-icon>
                                <span class="font-weight-medium">{{ item.raw.name }}</span>
                                <v-chip size="x-small" color="grey-darken-1" text-color="white" class="ml-2 timezone-code">
                                  {{ item.raw.value.split('/')[1].replace('_', ' ') }}
                                </v-chip>
                              </div>
                            </template>

                            <template v-slot:item="{ props, item, index }">
                              <v-list-item v-bind="props" class="timezone-item" :id="'timezone-modelmanagement-option-' + index" :value="item.raw.name">
                                <template v-slot:title>
                                  <div class="timezone-item-content">
                                    <span class="timezone-country font-weight-medium" style="margin-left: 5px">{{ item.raw.name }}</span>
                                    <div class="timezone-details d-flex align-center mt-1">
                                      <v-chip size="x-small" color="grey-darken-1" text-color="white" class="timezone-code">{{ item.raw.value.replace('_', ' ') }} </v-chip>
                                    </div>
                                  </div>
                                </template>
                              </v-list-item>
                            </template>
                          </v-select>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <!-- Reasoning Effort -->
                <v-col cols="4">
                  <transition name="fade">
                    <v-card
                      v-if="showReasoningEffort"
                      class="option-card d-flex flex-column mb-3"
                      style="background-color: #fff2f2"
                      :class="{ 'option-active': LLmsModel.reasoningEffort }"
                      flat
                      height="100%"
                      min-height="90px"
                    >
                      <div class="d-flex justify-space-between align-start">
                        <div class="option-header mb-auto">
                          <div class="d-flex align-center">
                            <span style="font-weight: 600">{{ $t("reasoningEffort") }}</span>
                            <v-tooltip top max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_tipReasoningDepth") }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </div>

                      <v-select
                        id="reasoning-ModelManagement"
                        v-model="LLmsModel.reasoningEffort"
                        :items="reasonOptions"
                        :class="LLmsModel.reasoningEffort ? 'input--enabled' : 'input--disabled'"
                        :rules="showReasoningEffort ? [rules.required] : [rules.notRequired]"
                        item-title="text"
                        item-value="value"
                        density="compact"
                        variant="outlined"
                        hide-details
                        :placeholder="$t('selectLevel')"
                        class="mt-1 rounded-input padding-input"
                      >
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'reasoningeffort-gptmodeldetail-option-' + index" :value="item.raw.text">
                            <template v-slot:title>
                              <span>{{ item.raw.text }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div class="d-flex align-center">
                            <v-chip size="small" :color="getReasoningColor(item.raw.value)" text-color="white" class="px-3 reasoning-chip">
                              {{ item.raw.text }}
                            </v-chip>
                          </div>
                        </template>
                      </v-select>
                    </v-card>
                  </transition>
                </v-col>
              </v-row>

              <!-- Line Configuration -->
              <div class="pa-3">
                <v-row style="background-color: #fff2f2; border-radius: 15px; padding: 8px">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex align-center justify-start gap-2">
                          <img src="@/assets/ri_line-fill.svg" alt="Line Icon" width="20" height="20" />
                          <span style="font-size: 18px; font-weight: 600">{{ $t("lineConfiguration") }}</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex align-center">
                      <v-col cols="3" class="mt-4">
                        <v-switch
                          id="loadingbar-enabled-switch-modelmanagement"
                          class="memory-switch"
                          v-model="LLmsModel.loadingBarFlag"
                          :label="$t('loadingBarLabel', { status: LLmsModel.loadingBarFlag ? $t('enabled') : $t('disabled') })"
                          color="primary"
                          @click="disabledConfig()"
                        ></v-switch>
                      </v-col>
                      <v-col cols="4" style="margin-top: -36px">
                        <span>{{ $t("loadingDuration") }}</span>
                        <v-autocomplete
                          id="loadingduration-autocomplete-modelmanagement"
                          :placeholder="$t('loadingDuration')"
                          clearable
                          class="model-input-control mt-2"
                          :class="LLmsModel.loadingBarFlag ? 'input--enabled' : 'input--disabled'"
                          :items="listLoadingDuration"
                          variant="none"
                          density="compact"
                          v-model="LLmsModel.loadingBarDuration"
                          :disabled="!LLmsModel.loadingBarFlag"
                          persistent-hint
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'loadingduration-gptmodeldetail-option-' + index" :value="item.raw">
                              <template v-slot:title>
                                <span>{{ item.raw }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <!-- Monitor -->
                    <v-row style="margin-top: -16px">
                      <v-col cols="12">
                        <span style="font-size: 18px; font-weight: 600">{{ $t("monitor") }}</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -8px">
                      <v-col cols="12" sm="12" md="4">
                        <span>{{ $t("monitorLineUserId") }}</span>
                        <v-text-field
                          id="monitor-line-userid-modelmanagement"
                          :placeholder="$t('monitorLineUserId')"
                          class="model-input-control mt-2"
                          v-model="LLmsModel.monitorLineUserID"
                          variant="none"
                          density="compact"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoMonitorLINEUserid') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span>{{ $t("monitorLineName") }}</span>
                        <v-autocomplete
                          id="monitor-line-name-modelmanagement"
                          :placeholder="$t('monitorLineName')"
                          class="model-input-control mt-2"
                          :items="listMonitorLineName"
                          density="compact"
                          clearable
                          variant="none"
                          item-title="name"
                          :class="LLmsModel.monitorSocialID ? 'input--enabled' : 'input--disabled'"
                          item-value="id"
                          v-model="LLmsModel.monitorSocialID"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'monitor-line-name-gptmodeldetail-option-' + index" :value="item.raw.name">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="4">
                        <v-card
                          class="option-card d-flex flex-column"
                          :class="{ 'option-active': LLmsModel.isShowNameUserMonitor }"
                          flat
                          height="100%"
                          :style="LLmsModel.isShowNameUserMonitor ? 'background: #FFFFFF;' : 'background: #EDEDED;'"
                          min-height="78px"
                        >
                          <div class="d-flex justify-space-between align-start">
                            <div class="option-header">
                              <div class="d-flex align-center gap-2">
                                <span class="font-weight-medium">{{ $t("showLineName") }}</span>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                  </template>
                                  <span>{{ $t("_tipShowLineName") }}</span>
                                </v-tooltip>
                              </div>
                              <div class="grey--text text-caption mt-1">{{ $t("_includeLineNameMonitoring") }}</div>
                            </div>
                            <v-switch id="showname-usermonitor-switch" v-model="LLmsModel.isShowNameUserMonitor" class="memory-switch" @click="disabledConfig()"></v-switch>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <!-- Forbidden Word -->
                    <v-row>
                      <v-col cols="12">
                        <v-toolbar-title style="font-size: 18px">{{ $t("forbiddenWord") }}</v-toolbar-title>
                      </v-col>
                    </v-row>
                    <div class="forbidden-container">
                      <div v-if="!LLmsModel.forbiddenWord || LLmsModel.forbiddenWord.length === 0" class="forbidden-empty">
                        <span>{{ $t("_noForbiddenWords") }}</span>
                      </div>
                      <transition-group name="forbidden-fade" tag="div" class="forbidden-list">
                        <div class="forbidden-item" v-for="(item, index) in LLmsModel.forbiddenWord" :key="`forbidden-${index}`">
                          <div class="forbidden-index">{{ index + 1 }}</div>
                          <v-text-field
                            :id="`forbiddenword-textfield-${index}`"
                            v-model="LLmsModel.forbiddenWord[index]"
                            variant="outlined"
                            density="compact"
                            class="forbidden-input"
                            :placeholder="$t('enterForbiddenWord')"
                            hide-details
                            @keydown.enter.prevent
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top" :open-delay="500">
                                <template v-slot:activator="{ props }">
                                  <v-icon size="16" color="#9CA3AF" style="cursor: help" v-bind="props"> mdi-information-outline </v-icon>
                                </template>
                                <span>{{ $t("_tipForbiddenWord") }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                          <v-btn icon="mdi-delete-outline" variant="text" color="grey-darken-1" class="forbidden-delete" @click="removeForbiddenWord(index)">
                            <v-tooltip location="top" :open-delay="300">
                              <template v-slot:activator="{ props }">
                                <v-icon size="18" color="#EF4444" v-bind="props">mdi-delete-forever</v-icon>
                              </template>
                              <span>{{ $t("remove") }}</span>
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </transition-group>
                      <div class="forbidden-footer">
                        <button type="button" id="button-add-forbiddenword-modelmanagement" class="forbidden-add-btn" @click="addForbiddenWord">
                          <img src="@/assets/plus.svg" alt="Plus Icon" width="16" height="16" />
                          <span style="color: #c32e0e; font-size: 14px">{{ $t("addWord") }}</span>
                        </button>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>

            <!-- Test Runs — run จากเมนู /ValidationProcess ที่ใช้โมเดลนี้ (อ่านอย่างเดียว)
                 ต้องมี modelID ก่อน จึงไม่โผล่ตอนสร้างโมเดลใหม่ที่ยังไม่มี id -->
            <ModelValidationRuns v-if="showValidationRuns && modelID" :model-id="modelID" />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="page.includes('Playground')" cols="12" class="d-flex justify-end">
            <div style="display: flex; gap: 18px">
              <button type="button" class="add-example-section" @click="closePlayground">
                <img src="@/assets/line-md_close.svg" alt="img" width="16" height="16" />
                <span style="font-weight: 400; font-size: 14px; color: #c30000">{{ $t('close') }}</span>
              </button>
              <button type="button" class="footer-btn save" @click="savePlayground">
                <img src="@/assets/basil_save-solid.png" alt="img" width="20" height="20" />
                <span>{{ $t('save') }}</span>
              </button>
            </div>
          </v-col>
          <v-col v-else-if="page == 'Model Creator'" cols="12" justify="end" align="end">
          </v-col>
          <v-col v-else cols="12" justify="end" align="end">
            <div v-if="page != 'view model'">
              <v-btn class="dialog-close-btn" style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px" to="/GPTModelManagement">
                <Icon icon="line-md:close" style="font-size: 22px; color: #c32e0e; margin-right: 8px" />
                {{ $t("close") }}
              </v-btn>
              <v-btn
                id="button-saveandclose-modelmanagement"
                class="dialog-save-btn"
                style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 180px !important"
                :disabled="isSaveDisabled"
                @click="Save('s&c')"
              >
                <img src="@/assets/fluent_save-arrow-right-24-filled.png" alt="img" width="20" height="20" />
                {{ $t("saveAndClose") }}
              </v-btn>
              <v-btn class="dialog-save-btn-green" style="margin-left: 1em; border-radius: 25.342px; width: 89.863px" :disabled="isSaveDisabled" @click="Save('s')">
                <Icon icon="basil:save-solid" style="font-size: 22px; color: #ffffff; margin-right: 8px" />
                {{ $t("save") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-dialog v-model="dialogShowAll" width="500">
        <v-card max-width="500">
          <v-list density="compact" rounded>
            <v-subheader class="headline" style="color: #1d4f81; font-size: 20px; border-radius: 5px; writing-mode: horizontal-tb">{{ $t("PromptTemplate") }}</v-subheader>
            <v-divider :thickness="1" class="border-opacity-100"></v-divider>
            <v-container style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <v-list-item v-for="(item, i) in filteredPromptTemplates" :key="i" @click="SetSelectPromptTemplate(item)">
                <template v-slot:title>
                  <span :id="'list-nameprompttemplateall-modelmanagement-legacy-' + i">{{ item.name }}</span>
                </template>
              </v-list-item>
            </v-container>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="button-close-popupshowall-legacy-modelmanagement" color="blue darken-1" variant="text" @click="dialogShowAll = false">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Add Category Dialog -->
    <CategoryManageDialogs
      v-model:add-open="dialog_addCategory"
      v-model:rename-open="dialog_renameCategory"
      v-model:new-category-name="newCategoryName"
      v-model:rename-category-name="renameCategoryName"
      :category-name-options="categoryNameOptions"
      :filtered-categories="filteredCategoryDialogItems"
      @save="SaveCategory"
      @rename="RenameCategory"
      @delete="deleteCategory"
      @open-rename="openRenameCategoryDialog"
      @close-add="closeCategoryDialog"
      @close-rename="closeRenameCategoryDialog"
    />

    <v-dialog v-model="showNameRequiredDialog" max-width="460" persistent>
      <v-card class="required-name-dialog" elevation="0">
        <div class="required-name-header">
          <h3 class="required-name-title">{{ $t("incompleteInformation") }}</h3>
          <button type="button" @click="clearRequiredWarning" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ $t("_someRequiredInfo") }}</p>
          <ul v-if="requiredMissingFields.length" class="required-field-list">
            <li v-for="field in requiredMissingFields" :key="field">{{ field }}</li>
          </ul>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <button type="button" class="ok-required-btn" @click="clearRequiredWarning">{{ $t("ok") }}</button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog width="400" :model-value="saveLoading || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">{{ $t("_Loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
const LogTrace = checkPermissionTwo;
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import lineIcon from '@/assets/brand/line-icon.png';
import newSaveImg from '@/assets/Icons/white-save-floppy.svg';
import CategoryManageDialogs from '@/components/CategoryManageDialogs.vue';
import ModelValidationRuns from '@/components/ModelValidationRuns.vue';
import categoryOptionsMixin from '@/mixins/categoryOptionsMixin.js';
import providerModelOptionsMixin from '@/mixins/providerModelOptionsMixin.js';
import { DD_MINUTE_OPTIONS, DD_MODEL_OPTIONS, DD_GENDER_OPTIONS, MAX_CHAT_INPUT_LIMIT } from '@/constants/gptModelOptions.js';
import { getDefaultSampling, getSentSamplingParams, resolveSamplingRule } from '@/utils/llmSampling.js';

// เวลารอสูงสุดของ probe ต่อหนึ่งครั้ง ถ้าเกินนี้ถือว่าเช็คไม่สำเร็จเพื่อปลดล็อกปุ่ม Save
const PROBE_TIMEOUT_MS = 60000;

// GraphRAG (S13-P1) — ต้องตรงกับ GraphRagDefaults.SearchModes ฝั่ง backend เป๊ะ
// ถ้าเพิ่มโหมดที่ backend ไม่รู้จัก save จะถูกตีกลับ 400 จาก GraphRagUserSettings.Validate
const KG_SEARCH_MODES = ['fuzzy-first', 'semantic-first', 'bm25-node-name', 'hybrid-union', 'hybrid-rerank', 'baseline-vector-only'];

// ค่าเริ่มต้นของแผง Advanced Retrieval Settings — ตรงกับ GraphRagDefaults ฝั่ง backend
// ช่องที่เป็น null = ไม่ override ให้ใช้ค่าของกราฟที่ตั้งไว้ในหน้า Search Settings
const KG_RETRIEVAL_DEFAULTS = {
  useCitationContext: true,
  searchMode: 'fuzzy-first',
  maxHops: 3,
  fuzzyThreshold: 70,
  semanticThreshold: 0.65,
  maxContextNodes: 30,
  maxContextEdges: 60,
  baselineTopK: null,
  baselineMinSimilarity: null,
};

export default {
  name: 'ModelManagement',
  emits: ['is-event', 'update:modelValue'],
  components: { CategoryManageDialogs, ModelValidationRuns },
  mixins: [checkPermissionTwo, LogTrace, categoryOptionsMixin, providerModelOptionsMixin],
  props: {
    // The model object, bound two-way from the parent via v-model. A local editable
    // copy (see data().LLmsModel) is used internally so we never mutate the prop directly.
    modelValue: {
      type: Object,
      default: () => {
        return {
          typeLLM: 0,
          modelId: null,
          modelName: null,
          provider: null,
          model: null,
          APIVersion: null,
          extension: null,
          description: null,
          promptTemplate: '',
          gender: null,
          vectordbName: [],
          groupReplaceID: null,
          productGroupID: [],
          knowledgeGraphKeys: [],
          kgRetrievalConfig: { ...KG_RETRIEVAL_DEFAULTS },
          topVDB: null,
          productTopVDB: null,
          productCosine: null,
          internet: null,
          feedback: null,
          historyCount: null,
          historyMinute: null,
          temperature: null,
          topP: null,
          frequencyPenalty: null,
          presencePenalty: null,
          stop: null,
          maxTokens: null,
          llmTimeout: null,
          isStream: false,
          isBypass: false,
          isFeedback: false,
          isAllowImage: false,
          fileUploadLimit: null,
          versioning: null,
          isPublish: true,
          modelIDGroup: null,
          modelDisplay: null,
          Len_ShortMemory: null,
          IsLongTerm_Memory: false,
          IsChainMassage: false,
          LenChainMassage: null,
          TimeSecondChainMassage: null,
          Cosine: null,
          DataIntegrationID: null,
          SqlModelID: null,
          promptSqlNoData: null,
          guardRailModelID: null,
          IntentGroupID: null,
          maximumChatInput: MAX_CHAT_INPUT_LIMIT,
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [''],
          monitorLineUserID: null,
          monitorSocialID: null,
          isShowNameUserMonitor: false,
          modelType: null,
          styleImage: null,
          resFormatImage: null,
          quality: null,
          resolution: null,
          enableTime: null,
          timeZone: null,
          jsonRequest: null,
          reasoningEffort: null,
          endPointURL: null,
          apI_Key: null,
          isAllowLLMChange: false,
          flowGroupID: null,
          platform: null,
          categoryName: null,
        };
      },
    },
    // DDVector:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDataIntegration:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listSqlExtract:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDGroupReplace:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDPromptTemplate:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDProvider:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDModel:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDIntentGroup:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    GetDDModel: {
      type: String,
      default: null,
    },
    // editAction: {
    //   type: Boolean,
    //   default: false,
    // },
    modelID: {
      type: String,
      default: null,
    },
    page: {
      type: String,
      default: '-',
    },
    // default false เพื่อให้ dialog ใน PlayGround.vue ที่ใช้ component เดียวกันไม่เปลี่ยนหน้าตา
    // เปิดใช้ที่ /GPTModelDetail และ dialog "view model" ของ Version History ใน GPTModelManagement.vue
    showValidationRuns: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    id: null,
    activeTab: 0,
    valid: true,
    checkbox1: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: null,
    loading: true,
    switch1: true,
    enableFlag: false,
    txtToImgChecker: false,
    imageStyleOptions: [
      { text: 'Natural', value: 'natural' },
      { text: 'Vivid', value: 'vivid' },
    ],
    imageFormatOptions: [
      { text: 'URL', value: 'url' },
      { text: 'Base64 json', value: 'b64_json' },
    ],
    reasonOptions: [
      { text: 'Low', value: 'low' },
      { text: 'Medium', value: 'medium' },
      { text: 'High', value: 'high' },
    ],
    rules: {
      notRequired: () => true,
      required: (value) => !!value || 'Required.',
    },
    GPTModel_isPublish: false,
    DDVector: [],
    DDKnowledgeGraphs: [],
    loadingKnowledgeGraphs: false,
    DDGroupReplace: [],
    DDProductGroup: [],
    DDProvider: ['Azure', 'Google'],
    listDataIntegration: [],
    listSqlExtract: [],
    listGuardRailModel: [],
    DDMinute: DD_MINUTE_OPTIONS.map((o) => ({ ...o })),
    DDModel: DD_MODEL_OPTIONS.map((o) => ({ ...o })),
    DDModelShow: [],
    DDTimeZone: [
      {
        value: 'Asia/Bangkok',
        name: 'Thailand',
      },
      {
        value: 'Asia/Hong_Kong',
        name: 'Hong Kong',
      },
      {
        value: 'Asia/Tokyo',
        name: 'Japan',
      },
      {
        value: 'America/New_York',
        name: 'USA',
      },
      {
        value: 'Europe/London',
        name: 'England',
      },
      {
        value: 'Australia/Sydney',
        name: 'Australia',
      },
    ],
    images: {
      edit: editImg,
      delete: deleteImg,
      line: lineIcon,
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDProvider: [],
    platformOptions: [
      { text: 'Azure', value: 'Azure' },
        // { text: 'AWS Bedrock', value: 'AWS Bedrock' },
        { text: 'Google Vertex AI', value: 'Google' },
        // { text: 'Grok API (xAI)', value: 'Grok API (xAI)' },
        { text: 'Anthropic Direct', value: 'Anthropic' },
        // { text: 'OpenAI Direct', value: 'OpenAI' },
        // { text: 'Together AI', value: 'Together AI' },
        // { text: 'Fireworks AI', value: 'Fireworks AI' },
        // { text: 'DeepInfra', value: 'DeepInfra' },
        { text: 'Other', value: 'Other' },
    ],
    showMenu: false,
    x: 0,
    y: 0,
    DDPromptTemplate: [],
    DDGroupPromptTemplate: [],
    flowDropdown: [],
    PositionPromptTemplate: 0,
    showPromptTem: false,
    dialogShowAll: false,
    promptSqlNoDataDialog: false,
    promptSqlNoDataDraft: '',
    groupPromptTemplate: null,
    localEditAction: null,
    categories: [],
    categoryMenuOpen: false,
    dialog_addCategory: false,
    newCategoryName: '',
    dialog_renameCategory: false,
    renameCategoryName: '',
    renameCategoryTarget: null,
    listLoadingDuration: [10, 20, 30, 40, 50, 60],
    listMonitorLineName: [],
    showFileUpload: false,
    showReasoningEffort: false,
    saveLoading: false,
    totalTokens: null,
    intentAutocompleteDisabled: false,
    workflowPanelOpen: false,
    modelSettingOpen: false,
    chatSettingOpen: false,
    showNameRequiredDialog: false,
    requiredMissingFields: [],
    error: {
      maxTokens: {
        error: false,
        message: '',
      },
      temperature: {
        error: false,
        message: '',
      },
      topP: {
        error: false,
        message: '',
      },
    },
    // ผลการทดสอบค่าที่ตั้งไว้กับโมเดลจริง (ดู runModelProbe)
    modelProbe: {
      status: 'idle', // idle | running | ok | invalid-sampling | failed
      message: '',
      suggestion: null, // ค่าที่ทดสอบแล้วผ่าน เช่น { temperature: 1, topP: 1 }
      okFingerprint: null, // ค่าชุดล่าสุดที่ทดสอบผ่าน
      checked: null, // ค่าที่ถูกส่งไปทดสอบจริง { temperature, topP, model }
    },
    probeCache: {},
    samplingAutoAdjusted: false, // ตอนเลือก model ระบบปรับ temperature/top p ตาม rule ให้แล้ว (ใช้แสดงข้อความ)
    parametersHighlight: false, // ไฮไลต์กรอบแดงรอบส่วน Parameters ชั่วคราวตอนถูกเลื่อนมา
    parametersHighlightTimer: null,
    newSaveImg: newSaveImg,
    // Local editable copy of the incoming modelValue prop. All template v-models and
    // script assignments target this copy; changes are emitted back via update:modelValue.
    LLmsModel: JSON.parse(JSON.stringify(this.modelValue || {})),
    };
  },

  watch: {
    // editAction(newVal) {
    //   this.localEditAction = newVal;
    // },
    '$route.params.id': function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },
    // ค่าที่ส่งทดสอบเปลี่ยน (model/temperature/top p/...) ผลทดสอบเดิมไม่ตรงกับค่าบนจอแล้ว
    // ถ้าชุดนี้เคยทดสอบไว้ให้ใช้ผลเดิม ไม่งั้นกลับเป็นสถานะยังไม่ได้ทดสอบ (ไม่ยิงเทสเอง ต้องกดปุ่ม)
    currentProbeFingerprint(fingerprint) {
      if (this.isProbing) return;
      this.restoreProbeOutcome(fingerprint);
    },
    'LLmsModel.provider': function (val) {
      if (val == null) {
        this.LLmsModel.vectordbName = [];
        this.LLmsModel.topVDB = null;
        this.LLmsModel.productGroupID = [];
        this.LLmsModel.productTopVDB = null;
      }
    },
    'LLmsModel.flowGroupID': {
      handler(newVal) {
        if (newVal) {
          this.LLmsModel.IntentGroupID = null;
        }
        this.intentAutocompleteDisabled = Boolean(newVal);
      },
      immediate: true,
    },
    // Parent replaced the whole model (v-model): resync the local copy and re-init dropdowns.
    // Guarded by a value compare so self-emitted echoes don't re-run the init on every edit.
    modelValue: {
      deep: true,
      handler(val) {
        if (JSON.stringify(val) === JSON.stringify(this.LLmsModel)) {
          return;
        }
        this.LLmsModel = JSON.parse(JSON.stringify(val || {}));
        this.normalizeGraphRagFields();
        if (!val) {
          return;
        }

        if (val.platform) {
          this.changePlatform(val.platform, { preserveModel: true });
        } else if (val.provider) {
          this.changeProvider(val.provider, { preserveModel: true });
        }

        if (val.model) {
          this.changeModel(this.buildModelSelectionValue(val.model, val.modelNameDisplay));
        }
      },
    },
    // Local edits: push the updated model up to the parent to keep v-model in sync.
    LLmsModel: {
      deep: true,
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.modelValue)) {
          this.$emit('update:modelValue', JSON.parse(JSON.stringify(val)));
        }
      },
    },
  },
  computed: {
    maxChatInputLimit() {
      return MAX_CHAT_INPUT_LIMIT;
    },
    kgSearchModes() {
      return KG_SEARCH_MODES;
    },
    hasKnowledgeGraphSelected() {
      return Array.isArray(this.LLmsModel.knowledgeGraphKeys) && this.LLmsModel.knowledgeGraphKeys.length > 0;
    },
    DDGender() {
      return DD_GENDER_OPTIONS.map((o) => ({ id: o.id, name: this.$t(o.i18nKey) }));
    },
    categoryOptions() {
      return this.dedupeCategories(this.categories);
    },
    categoryNameOptions() {
      return this.categoryOptions.map((category) => category.name);
    },
    filteredCategoryDialogItems() {
      const keyword = this.normalizeCategoryName(this.newCategoryName);
      const items = this.categoryOptions;

      if (!keyword) {
        return items;
      }

      return items.filter((category) => this.normalizeCategoryName(category.name).includes(keyword));
    },
    availableProviders() {
      if (!this.LLmsModel.platform) {
        return [];
      }

      return this.getProviderOptionsForPlatform(this.LLmsModel.platform);
    },
    isProviderSelectionDisabled() {
      return !this.LLmsModel.platform || Boolean(this.getFixedProviderByPlatform(this.LLmsModel.platform));
    },
    isModelSelectionDisabled() {
      return false;
    },
    modelSelectionOptions() {
      return Array.isArray(this.listDDModel) ? this.listDDModel : [];
    },
    selectedModelInfo() {
      return this.findModelDefinition(this.LLmsModel?.model, this.modelSelectionOptions);
    },
    probeCheckedValues() {
      const checked = this.modelProbe.checked || {};
      return {
        temperature: this.formatProbeValue(checked.temperature),
        topP: this.formatProbeValue(checked.topP),
        model: checked.model || '-',
      };
    },
    modelProbeMessage() {
      if (this.modelProbe.status === 'running') return this.$t('_probeChecking');
      if (this.modelProbe.status === 'ok') return this.isSamplingNotSent ? this.$t('_probeOkNotSent') : this.$t('_probeOkDetail', this.probeCheckedValues);
      return this.modelProbe.message;
    },
    // ระหว่างยิงเช็คกับโมเดลยังไม่เสร็จ ห้าม save (ปุ่มเป็นสีเทา)
    isProbing() {
      return this.modelProbe.status === 'running';
    },
    isSaveDisabled() {
      return this.saveLoading || this.isProbing;
    },
    // ใช้ทั้ง :disabled และ guard ใน onClickTestModel
    canRunModelProbe() {
      return !this.isProbing && !this.isBlank(this.LLmsModel.model) && !this.isBlank(this.LLmsModel.platform);
    },
    // ชุดค่าที่จะถูกส่งไปทดสอบ ถ้าเปลี่ยนจากชุดที่ทดสอบไว้ ผลเดิมใช้ไม่ได้แล้ว (ดู watcher)
    currentProbeFingerprint() {
      return this.buildProbeFingerprint();
    },
    // ค่าชุดปัจจุบันถูกกดทดสอบแล้วผ่าน — ผลทดสอบจริงมาก่อน rule ใน llmSamplingRules
    isProbePassed() {
      return this.modelProbe.okFingerprint !== null && this.modelProbe.okFingerprint === this.currentProbeFingerprint;
    },
    modelProbeInlineMessage() {
      if (this.modelProbe.status === 'running') return this.$t('_probeChecking');
      if (this.modelProbe.status === 'ok') return this.isSamplingNotSent ? this.$t('_probeOkNotSent') : this.$t('_probeOkInline', this.probeCheckedValues);
      return this.$t('_probeInlineFailed');
    },
    // ค่า temperature / top p บนจอถูกส่งไปที่โมเดลจริงไหม (ขึ้นกับ JSON Configuration ของ LLM)
    // Anthropic ไม่ส่ง top_p อยู่แล้วและช่อง Top P ถูก disable จึงไม่นับ
    samplingParamsSent() {
      const sent = getSentSamplingParams(this.LLmsModel.jsonRequest);
      return { temperature: sent.temperature, topP: sent.topP && this.isTopPEditable() };
    },
    isSamplingNotSent() {
      return !this.samplingParamsSent.temperature && !this.samplingParamsSent.topP;
    },
    // ชื่อ deployment + display ของ model ที่เลือก ใช้เทียบกับ llmSamplingRules
    selectedModelNames() {
      if (this.isBlank(this.LLmsModel.model)) return [];
      const selected = this.selectedModelInfo;
      const parts = this.getModelValueParts(selected?.modelName || this.LLmsModel.model);
      return [parts.model, parts.display, selected?.modelDisplay];
    },
    // model ที่เลือกอยู่ตรงกับ rule ตระกูลไหน (fixed / free / unknown) — null ถ้ายังไม่ได้เลือก
    samplingRuleInfo() {
      return this.selectedModelNames.length > 0 ? resolveSamplingRule(this.selectedModelNames) : null;
    },
    // ช่องที่ค่าไม่ตรง rule 'fixed' และค่าถูกส่งไปจริง = รู้แน่ว่าเรียกโมเดลไม่สำเร็จ ไม่ต้องรอทดสอบ
    samplingRuleViolations() {
      const info = this.samplingRuleInfo;
      if (info?.state !== 'fixed' || this.isProbePassed) return [];
      return ['temperature', 'topP']
        .filter((key) => this.samplingParamsSent[key] && this.toProbeNumber(this.LLmsModel[key]) !== info.rule[key])
        .map((key) => ({ key, expected: info.rule[key] }));
    },
    samplingRuleValues() {
      const rule = this.samplingRuleInfo?.rule;
      return rule ? { family: rule.family, temperature: rule.temperature, topP: rule.topP } : {};
    },
    samplingRuleMessage() {
      return this.samplingRuleInfo?.rule ? this.$t('_samplingRuleRejected', this.samplingRuleValues) : '';
    },
    // ข้อความใต้ dropdown Model: ผลทดสอบจริงมาก่อน ถ้ายังไม่ได้ทดสอบค่อยบอกตาม rule
    // model ที่ไม่อยู่ใน rule แค่เตือน (non-blocking) ยังบันทึกได้
    modelInlineNotice() {
      if (this.isBlank(this.LLmsModel.model) || this.isProbing) return null;
      if (this.modelProbe.status !== 'idle') {
        return { tone: this.modelProbe.status, text: this.modelProbeInlineMessage };
      }
      const info = this.samplingRuleInfo;
      if (!info || this.txtToImgChecker) return null;
      if (this.isSamplingNotSent) {
        return { tone: 'info', text: this.$t('_samplingNotSent') };
      }
      if (info.state === 'fixed') {
        if (this.samplingRuleViolations.length > 0) {
          return { tone: 'invalid-sampling', text: this.$t('_samplingRuleInvalidInline', this.samplingRuleValues) };
        }
        return { tone: 'info', text: this.$t(this.samplingAutoAdjusted ? '_samplingRuleAdjusted' : '_samplingRuleFixed', this.samplingRuleValues) };
      }
      if (info.state === 'unknown') {
        return { tone: 'warning', text: this.$t('_samplingUnknownModel') };
      }
      return null;
    },
    providerSelectionRules() {
      return [this.validateProviderSelection];
    },
    modelSelectionRules() {
      return [this.validateModelSelection];
    },
    modelNoDataText() {
      return 'No data available';
    },
    modelSupportsFileUpload() {
      const selectedModel = this.findModelDefinition(this.LLmsModel.model, this.modelSelectionOptions);
      return selectedModel ? selectedModel.useUploadFile : false;
    },
    filteredPromptTemplates() {
      if (this.groupPromptTemplate === null) {
        return [];
      }
      return this.DDPromptTemplate.filter((item) => item.groupPromptTemplateID === this.groupPromptTemplate);
    },
    searchedTemplates() {
      if (!this.templateSearchQuery) return this.filteredPromptTemplates;
      const query = this.templateSearchQuery.toLowerCase();
      return this.filteredPromptTemplates.filter((item) => item.name.toLowerCase().includes(query));
    },
    intentHelperText() {
      return this.intentAutocompleteDisabled ? '*You cannot select an Intent while a Flow is active.' : '';
    },
    promptSqlNoDataButtonIcon() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === '') {
        return 'mdi-plus';
      }
      return 'mdi-check';
    },
    promptSqlNoDataButtonText() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === '') {
        return 'Customize No Data Message';
      }
      return 'Using Custom Message';
    },
    longTermMemoryStatus() {
      const isEnabled = Boolean(this.LLmsModel?.IsLongTerm_Memory);
      return isEnabled ? 'Long-Term Memory Enabled' : 'Long-Term Memory Disabled';
    },
  },
  methods: {
    /**
     * พ่อ (GPTModelDetail.vue) แทน LLmsModel ทั้งก้อนผ่าน v-model — ก้อนที่ส่งมาอาจไม่มี 2 field นี้
     * (โมเดลเก่าที่บันทึกก่อนสไลซ์ S13-P1 หรือ default object ของพ่อรุ่นเก่า)
     * ถ้าไม่เติมให้ครบ template จะ throw ตอนกาง Advanced Retrieval Settings
     * เพราะ v-model ชี้ลึกเข้าไปใน LLmsModel.kgRetrievalConfig.* โดยตรง
     */
    normalizeGraphRagFields() {
      if (!Array.isArray(this.LLmsModel.knowledgeGraphKeys)) {
        this.LLmsModel.knowledgeGraphKeys = [];
      }

      this.LLmsModel.kgRetrievalConfig = { ...KG_RETRIEVAL_DEFAULTS, ...(this.LLmsModel.kgRetrievalConfig || {}) };
    },
    // ── GraphRAG (S13-P1) ─────────────────────────────────────────────────
    LoadKnowledgeGraphsForPicker() {
      const self = this;
      self.loadingKnowledgeGraphs = true;
      self.$call.GraphRagGetGraphs(
        '',
        (res) => {
          self.loadingKnowledgeGraphs = false;
          if (!res || res.status !== 0) {
            self.DDKnowledgeGraphs = [];
            return;
          }
          // GraphRagGraph/GetAll คืน paging envelope { page, perPage, total, data: [...] }
          // รูปแบบเดียวกับที่ GraphManager.vue:215 ใช้ — อย่าเดาเป็น items
          self.DDKnowledgeGraphs = res.data?.data || [];
        },
        () => {
          // บล็อกเสริม — โหลดไม่ได้ต้องไม่ขวางการบันทึกโมเดล และไม่เด้ง toast กวนผู้ใช้
          self.loadingKnowledgeGraphs = false;
          self.DDKnowledgeGraphs = [];
        }
      );
    },
    /**
     * ช่องว่าง = ไม่ override (ผ่านเสมอ) · มีค่าต้องเป็นตัวเลขในช่วงที่ backend รับ
     * ช่วงต้องตรงกับ GraphRagUserSettings.Validate ฝั่ง backend ไม่งั้น save ผ่าน UI แต่ถูกตีกลับ 400
     */
    kgRangeRule(labelKey, min, max) {
      return (value) => {
        if (value === null || value === undefined || value === '') return true;

        const num = Number(value);
        if (Number.isNaN(num) || num < min || num > max) {
          return `${this.$t(labelKey)}: ${min} - ${max}`;
        }

        return true;
      };
    },
    /** '' / null → null · ที่เหลือ → number (input type=number ใน Vuetify คืน string) */
    kgNumberOrNull(value) {
      if (value === null || value === undefined || value === '') return null;

      const num = Number(value);
      return Number.isNaN(num) ? null : num;
    },
    /** ประกอบ payload ที่ส่งขึ้น backend — ไม่มีกราฟ = ส่ง null ทั้งคู่ */
    buildKgRetrievalConfigPayload() {
      if (!this.hasKnowledgeGraphSelected) return null;

      const config = this.LLmsModel.kgRetrievalConfig || {};

      return {
        useCitationContext: config.useCitationContext !== false,
        searchMode: config.searchMode || null,
        maxHops: this.kgNumberOrNull(config.maxHops),
        fuzzyThreshold: this.kgNumberOrNull(config.fuzzyThreshold),
        semanticThreshold: this.kgNumberOrNull(config.semanticThreshold),
        maxContextNodes: this.kgNumberOrNull(config.maxContextNodes),
        maxContextEdges: this.kgNumberOrNull(config.maxContextEdges),
        baselineTopK: this.kgNumberOrNull(config.baselineTopK),
        baselineMinSimilarity: this.kgNumberOrNull(config.baselineMinSimilarity),
      };
    },
    normalizeLookupValue(value) {
      return typeof value === 'string' ? value.trim().toLowerCase() : '';
    },
    findExistingCategory(name) {
      const normalizedName = this.normalizeCategoryName(name);

      if (!normalizedName) {
        return null;
      }

      return this.categoryOptions.find((category) => this.normalizeCategoryName(category.name) === normalizedName) || null;
    },
    findCategoryByName(name, excludeId = null) {
      const normalizedName = this.normalizeCategoryName(name);

      if (!normalizedName) {
        return null;
      }

      return this.categoryOptions.find((category) => {
        if (excludeId !== null && category.id === excludeId) {
          return false;
        }

        return this.normalizeCategoryName(category.name) === normalizedName;
      }) || null;
    },
    syncSelectedCategoryName() {
      const existingCategory = this.findExistingCategory(this.LLmsModel?.categoryName);
      if (existingCategory) {
        this.LLmsModel.categoryName = existingCategory.name;
        return;
      }

      const normalizedName = this.normalizeCategoryDisplayName(this.LLmsModel?.categoryName);
      this.LLmsModel.categoryName = normalizedName || null;
    },
    reloadCategories(selectedCategoryName = null) {
      try {
        if (typeof this.$call.GetGPTModelCategory !== 'function') {
          return;
        }

        this.$call.GetGPTModelCategory(
          (res) => {
            if (res && res.status == 0) {
              this.categories = this.dedupeCategories(res.data || []);
              if (selectedCategoryName !== null) {
                this.LLmsModel.categoryName = selectedCategoryName;
              }
              this.syncSelectedCategoryName();
            }
          },
          () => {}
        );
      } catch (e) { console.error(e); /* category refresh is optional; ignore failure */ }
    },
    matchesProvider(providerName, selectedProvider) {
      const normalizedProviderName = this.normalizeLookupValue(providerName);
      const normalizedSelectedProvider = this.normalizeLookupValue(selectedProvider);
      return normalizedProviderName !== '' && normalizedProviderName === normalizedSelectedProvider;
    },
    matchesPlatform(modelPlatform, selectedPlatform) {
      const normalizedSelectedPlatform = this.normalizeLookupValue(selectedPlatform);
      const normalizedModelPlatform = this.normalizeLookupValue(modelPlatform);

      if (!normalizedSelectedPlatform) {
        return false;
      }

      return normalizedModelPlatform === normalizedSelectedPlatform;
    },
    matchesModelSelection(model, selectedProvider, selectedPlatform) {
      if (!this.matchesProvider(model?.provider, selectedProvider)) {
        return false;
      }

      return this.matchesPlatform(model?.platform, selectedPlatform);
    },
    getModelsForSelection(provider, platform) {
      if (!Array.isArray(this.listDDModel) || this.listDDModel.length === 0) {
        return [];
      }

      return this.listDDModel.filter((model) => this.matchesModelSelection(model, provider, platform));
    },
    getFixedProviderByPlatform(platform) {
      const map = {
        Google: 'Google',
        Anthropic: 'Anthropic',
      };

      return map[platform] ?? null;
    },
    getModelValueParts(value) {
      const raw = typeof value === 'string' ? value.trim() : '';
      if (!raw) {
        return { raw: '', model: '', display: '' };
      }

      const parts = raw.split('|');
      const model = (parts.shift() || '').trim();
      const display = parts.length > 0 ? parts.join('|').trim() : '';
      return { raw, model, display };
    },
    getModelSelectionDisplay(model) {
      return model?.modelDisplay || this.getModelValueParts(model?.modelName).display || model?.modelName || '';
    },
    buildModelSelectionValue(model, modelNameDisplay) {
      const rawModel = typeof model === 'string' ? model.trim() : '';
      const display = typeof modelNameDisplay === 'string' ? modelNameDisplay.trim() : '';

      if (!rawModel) {
        return display;
      }

      if (rawModel.includes('|') || !display) {
        return rawModel;
      }

      return `${rawModel}|${display}`;
    },
    isAnthropicValue(value) {
      const normalizedValue = this.normalizeLookupValue(value);
      return normalizedValue.includes('anthropic') || normalizedValue.includes('claude');
    },
    requiresApiVersion(platform = this.LLmsModel.platform, provider = this.LLmsModel.provider) {
      return this.isAnthropicValue(platform) || this.isAnthropicValue(provider);
    },
    isApiVersionMissing() {
      const apiVersion = typeof this.LLmsModel.APIVersion === 'string' ? this.LLmsModel.APIVersion.trim() : this.LLmsModel.APIVersion;
      return this.requiresApiVersion() && (apiVersion == '' || apiVersion == null);
    },
    getApiVersionForSave() {
      if (!this.requiresApiVersion()) {
        return null;
      }

      return typeof this.LLmsModel.APIVersion === 'string' ? this.LLmsModel.APIVersion.trim() : this.LLmsModel.APIVersion;
    },
    getComparableModelValues(value) {
      if (typeof value !== 'string') {
        return [];
      }

      const parts = this.getModelValueParts(value);
      const normalizedValue = this.normalizeModelValue(value);
      const modelWithDisplay = this.buildModelSelectionValue(parts.model, parts.display);

      return [...new Set([parts.raw, modelWithDisplay, normalizedValue, parts.display, parts.model].filter(Boolean))];
    },
    findModelDefinition(value, models = this.listDDModel) {
      if (!Array.isArray(models) || models.length === 0 || typeof value !== 'string') {
        return null;
      }

      const target = this.getModelValueParts(value);
      const normalize = (targetValue) => this.normalizeLookupValue(targetValue);
      const exactValue = models.find((model) => normalize(model?.modelName) === normalize(target.raw));
      if (exactValue) {
        return exactValue;
      }

      if (target.display) {
        const exactDisplay = models.find((model) => {
          const modelParts = this.getModelValueParts(model?.modelName);
          return normalize(model?.modelDisplay) === normalize(target.display) && (!target.model || normalize(modelParts.model) === normalize(target.model));
        });
        if (exactDisplay) {
          return exactDisplay;
        }
      }

      const displayOnly = models.find((model) => normalize(model?.modelDisplay) === normalize(target.raw));
      if (displayOnly) {
        return displayOnly;
      }

      const normalizedValue = normalize(this.normalizeModelValue(value));
      const normalizedMatch = models.find((model) => normalize(this.normalizeModelValue(model?.modelName)) === normalizedValue);
      if (normalizedMatch) {
        return normalizedMatch;
      }

      return models.find((model) => normalize(this.getModelValueParts(model?.modelName).model) === normalize(target.model || target.raw)) || null;
    },
    resetModelSelection() {
      this.LLmsModel.model = null;
      this.totalTokens = null;
      this.maxLengthChar = null;
      this.txtToImgChecker = false;
      this.showReasoningEffort = false;
      this.showFileUpload = false;
      this.LLmsModel.isAllowImage = false;
      this.LLmsModel.fileUploadLimit = null;
      this.LLmsModel.styleImage = null;
      this.LLmsModel.resFormatImage = null;
      this.LLmsModel.quality = null;
      this.LLmsModel.resolution = null;
      this.LLmsModel.modelType = null;
      this.LLmsModel.APIVersion = null;
      this.LLmsModel.jsonRequest = null;
      this.LLmsModel.reasoningEffort = null;
      this.LLmsModel.endPointURL = null;
      this.LLmsModel.apI_Key = null;
      this.LLmsModel.authenHeaderName = null;
    },
    handleProviderChange(value) {
      return this.changeProvider(value);
    },
    async handleModelChange(value) {
      // ไม่ยิงทดสอบเอง ผู้ใช้กดปุ่ม Test Model ใต้ dropdown ได้ถ้าต้องการ (onClickTestModel)
      const result = await this.changeModel(value);
      // ผู้ใช้เลือก model เอง: ตั้ง temperature / top p ตามค่าเริ่มต้นของตระกูล (GPT-4 = 0, ตัวอื่น = 1)
      // (ตอนเปิด model เดิมไม่ผ่านตรงนี้ จึงไม่แก้ค่าที่เซฟไว้เงียบ ๆ ถ้าขัด rule แค่ขึ้นแดงพร้อมปุ่มแก้)
      this.samplingAutoAdjusted = false;
      if (this.selectedModelNames.length > 0) {
        this.applyDefaultSampling();
        this.samplingAutoAdjusted = true;
      }
      return result;
    },
    validateProviderSelection(value) {
      if (!this.LLmsModel.platform) {
        return 'Please select platform first.';
      }

      return !!value || 'Required.';
    },
    validateModelSelection(value) {
      if (!value) {
        return 'Required.';
      }

      return value.split('')[0] !== '|' || 'Please select model';
    },
    openPromptSqlNoDataDialog() {
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? '';
      this.promptSqlNoDataDialog = true;
    },
    cancelPromptSqlNoDataDialog() {
      this.promptSqlNoDataDialog = false;
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? '';
    },
    savePromptSqlNoData() {
      const value = this.promptSqlNoDataDraft?.trim();
      this.LLmsModel.promptSqlNoData = value && value !== '' ? value : null;
      this.promptSqlNoDataDialog = false;
    },
    getReasoningColor(level) {
      switch (level) {
        case 'low':
          return 'blue-grey';
        case 'medium':
          return 'blue darken-1';
        case 'high':
          return 'indigo darken-2';
        default:
          return 'grey';
      }
    },
    truncatePrompt(text) {
      if (!text) return '';
      return text.length > 60 ? text.substring(0, 60) + '...' : text;
    },
    addForbiddenWord() {
      if (Array.isArray(this.LLmsModel.forbiddenWord)) {
        this.LLmsModel.forbiddenWord.push('');
      } else {
        this.LLmsModel.forbiddenWord = [''];
      }

      const newIndex = this.LLmsModel.forbiddenWord.length - 1;
      this.$nextTick(() => {
        const input = this.$el?.querySelector(`#forbiddenword-textfield-${newIndex} input`);
        if (input) {
          input.focus();
        }
      });
    },
    removeForbiddenWord(index) {
      if (!Array.isArray(this.LLmsModel.forbiddenWord) || this.LLmsModel.forbiddenWord.length === 0) {
        return;
      }

      if (this.LLmsModel.forbiddenWord.length <= 1) {
        this.LLmsModel.forbiddenWord.splice(0, 1, '');
      } else {
        this.LLmsModel.forbiddenWord.splice(index, 1);
      }
    },
    disabledConfig() {
      this.enableFlag = !this.LLmsModel.loadingBarFlag;
      return this.enableFlag;
    },
    ShowPromptTemplate(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async SetSelectPromptTemplate(val) {
      const strArray = this.LLmsModel.promptTemplate.split('');
      strArray.splice(this.PositionPromptTemplate, 0, val.prompt);
      this.LLmsModel.promptTemplate = strArray.join('');
    },
    validate() {
      this.$refs.form.validate();
    },
    async Get(id) {
      this.dialog = true;
      this.loading = true;
      await this.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            await this.Edit(dataResponse.data);
            await this.changePlatform(this.LLmsModel.platform, { preserveModel: true });
            await this.changeModel(this.LLmsModel.model);
            this.disabledConfig();
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    applyModelManagementDropdownData(data) {
      this.DDVector = data.vectorDBName;
      this.listDataIntegration = data.dataIntegration;
      this.DDGroupReplace = data.groupReplace;
      this.DDProductGroup = data.productGroup;
      this.DDProductGroup = data.productGroup;
      this.DDPromptTemplate = data.promptTemplate.listData;
      this.listDDProvider = data.provider;
      this.listDDModel = data.modelData;
      this.listDDIntentGroup = data.intentGroup;
      this.DDGroupPromptTemplate = data.groupPromptTemplate;
      this.listMonitorLineName = data.monitorSocialLine;
      this.flowDropdown = data.flowDropdown;
      if (this.modelID) {
        this.listSqlExtract = data.modelPublih.filter((e) => e.idEncrypt != this.modelID && e.typeName == 'Bot');
      } else {
        this.listSqlExtract = data.modelPublih.filter((e) => e.typeName == 'Bot');
      }
      this.listGuardRailModel = data.modelPublih.filter((e) => e.typeName == 'GuardRail');
    },
    resetModelManagementDropdownData() {
      this.DDVector = [];
      this.listDataIntegration = [];
      this.listSqlExtract = [];
      this.listGuardRailModel = [];
      this.DDGroupReplace = [];
      this.DDProductGroup = [];
      this.DDPromptTemplate = [];
      this.listDDProvider = [];
      this.listDDModel = [];
    },
    async finalizeModelManagementLoad() {
      if (this.modelID != null) {
        await this.Get(this.modelID);
      }

      if (this.page.includes('Playground')) {
        this.localEditAction = this.page.includes('Edit');
        await this.changePlatform(this.LLmsModel.platform, { preserveModel: true });
        await this.changeModel(this.LLmsModel.model);
        return;
      }

      this.localEditAction = false;
    },
    async GetAllDDModelManagement() {
      const id = this.$route.query.id ?? this.LLmsModel.modelId;
      this.dialog = true;
      await this.$call.GetAllDDModelManagement(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            this.applyModelManagementDropdownData(dataResponse.data);
          } else {
            this.resetModelManagementDropdownData();
          }
          this.dialog = false;
          await this.finalizeModelManagementLoad();
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    normalizeEmptyValue(value) {
      return value === '' ? null : value;
    },
    normalizeOptionalText(value) {
      return value != '' && value != null ? value : null;
    },
    normalizeArrayValue(value) {
      return value == null ? [] : value;
    },
    getSaveModelDisplayName(selectedModelForSave) {
      return selectedModelForSave?.modelDisplay || this.getModelValueParts(this.LLmsModel.model).display || null;
    },
    getSaveModelHistoryMinute() {
      return this.LLmsModel.historyMinute > 0 ? -this.LLmsModel.historyMinute : this.LLmsModel.historyMinute;
    },
    getSaveModelMaxTokens() {
      return this.LLmsModel.maxTokens == null || this.LLmsModel.maxTokens == '' ? this.totalTokens : this.LLmsModel.maxTokens;
    },
    getSaveModelFileUploadLimit() {
      return this.LLmsModel.fileUploadLimit == null ? this.LLmsModel.fileUploadLimit : Number.parseInt(this.LLmsModel.fileUploadLimit);
    },
    getSaveModelLongTermMemory() {
      return this.LLmsModel.provider == 'Google' ? false : (this.LLmsModel.IsLongTerm_Memory ?? false);
    },
    getSaveModelTypingSpeed() {
      return Number.parseInt(this.LLmsModel.typingSpeed);
    },
    getSaveModelMaximumChatInput() {
      return this.LLmsModel.maximumChatInput == null ? MAX_CHAT_INPUT_LIMIT : Number.parseInt(this.LLmsModel.maximumChatInput);
    },
    getSaveImageSetting(fieldName) {
      return this.txtToImgChecker ? this.LLmsModel[fieldName] : null;
    },
    getSaveModelTypeLabel() {
      return this.LLmsModel.typeLLM == 1 ? 'GuardRail' : 'Bot';
    },
    getSaveGuardRailModelId() {
      return this.LLmsModel.typeLLM == 0 ? this.LLmsModel.guardRailModelID : null;
    },
    getSaveModelTimeZone() {
      return this.LLmsModel.enableTime ? this.LLmsModel.timeZone : null;
    },
    getSaveModelReasoningEffort() {
      return this.showReasoningEffort ? (this.LLmsModel.reasoningEffort || 'low') : null;
    },
    getSaveModelCategoryId() {
      return this.LLmsModel.categoryName ? (this.findExistingCategory(this.LLmsModel.categoryName)?.id ?? null) : null;
    },
    getSaveModelData() {
      const selectedModelForSave = this.findModelDefinition(this.LLmsModel.model, this.DDModelShow) || this.findModelDefinition(this.LLmsModel.model);

      return {
        modelId: this.LLmsModel.modelId,
        modelName: this.LLmsModel.modelName,
        provider: this.LLmsModel.provider,
        model: this.normalizeModelValue(selectedModelForSave?.modelName || this.LLmsModel.model),
        modelNameDisplay: this.getSaveModelDisplayName(selectedModelForSave),
        APIVersion: this.getApiVersionForSave(),
        extension: this.LLmsModel.extension,
        description: this.LLmsModel.description,
        promptTemplate: this.LLmsModel.promptTemplate,
        gender: this.LLmsModel.gender,
        vectordbName: this.normalizeArrayValue(this.LLmsModel.vectordbName),
        groupReplaceID: this.normalizeArrayValue(this.LLmsModel.groupReplaceID),
        productGroupID: this.normalizeArrayValue(this.LLmsModel.productGroupID),
        knowledgeGraphKeys: this.hasKnowledgeGraphSelected ? this.LLmsModel.knowledgeGraphKeys : null,
        kgRetrievalConfig: this.buildKgRetrievalConfigPayload(),
        topVDB: this.normalizeEmptyValue(this.LLmsModel.topVDB),
        productTopVDB: this.normalizeEmptyValue(this.LLmsModel.productTopVDB),
        productCosine: this.LLmsModel.productCosine === '' ? null : this.LLmsModel.productTopVDB,
        internet: this.LLmsModel.internet,
        feedback: this.LLmsModel.feedback,
        historyCount: this.LLmsModel.historyCount,
        historyMinute: this.getSaveModelHistoryMinute(),
        temperature: this.normalizeEmptyValue(this.LLmsModel.temperature),
        topP: this.normalizeEmptyValue(this.LLmsModel.topP),
        frequencyPenalty: this.normalizeEmptyValue(this.LLmsModel.frequencyPenalty),
        presencePenalty: this.normalizeEmptyValue(this.LLmsModel.presencePenalty),
        stop: this.normalizeEmptyValue(this.LLmsModel.stop),
        maxTokens: this.getSaveModelMaxTokens(),
        llmTimeout: this.normalizeEmptyValue(this.LLmsModel.llmTimeout),
        isStream: this.LLmsModel.isStream,
        isFeedback: this.LLmsModel.isFeedback,
        isAllowImage: this.LLmsModel.isAllowImage,
        fileUploadLimit: this.getSaveModelFileUploadLimit(),
        versioning: this.LLmsModel.versioning,
        isPublish: this.LLmsModel.isPublish,
        modelIDGroup: this.LLmsModel.modelIDGroup,
        modelDisplay: this.LLmsModel.modelDisplay,
        Len_ShortMemory: this.LLmsModel.Len_ShortMemory ?? 200,
        IsLongTerm_Memory: this.getSaveModelLongTermMemory(),
        IsChainMassage: this.LLmsModel.IsChainMassage ?? false,
        LenChainMassage: this.LLmsModel.LenChainMassage,
        TimeSecondChainMassage: this.LLmsModel.TimeSecondChainMassage,
        Cosine: this.LLmsModel.Cosine,
        DataIntegrationID: this.LLmsModel.DataIntegrationID,
        SqlModelID: this.LLmsModel.SqlModelID,
        promptSqlNoData: this.LLmsModel.promptSqlNoData,
        IntentGroupID: this.LLmsModel.IntentGroupID,
        typingSpeed: this.getSaveModelTypingSpeed(),
        maximumChatInput: this.getSaveModelMaximumChatInput(),
        loadingBarFlag: this.LLmsModel.loadingBarFlag,
        loadingBarDuration: this.LLmsModel.loadingBarDuration,
        forbiddenWord: this.forbiddenWordSaveHandle(this.LLmsModel.forbiddenWord),
        monitorLineUserID: this.LLmsModel.monitorLineUserID,
        isShowNameUserMonitor: this.LLmsModel.isShowNameUserMonitor,
        monitorSocialID: this.LLmsModel.monitorSocialID,
        styleImage: this.getSaveImageSetting('styleImage'),
        resFormatImage: this.getSaveImageSetting('resFormatImage'),
        modelType: this.LLmsModel.modelType,
        quality: this.getSaveImageSetting('quality'),
        resolution: this.getSaveImageSetting('resolution'),
        JsonRequest: this.LLmsModel.jsonRequest,
        typeLLM: this.getSaveModelTypeLabel(),
        guardRailModelID: this.getSaveGuardRailModelId(),
        timeZone: this.getSaveModelTimeZone(),
        reasoningEffort: this.getSaveModelReasoningEffort(),
        endPointURL: this.normalizeOptionalText(this.LLmsModel.endPointURL),
        apI_Key: this.normalizeOptionalText(this.LLmsModel.apI_Key),
        authenHeaderName: this.normalizeOptionalText(this.LLmsModel.authenHeaderName),
        platform: this.normalizeOptionalText(this.LLmsModel.platform),
        isAllowLLMChange: this.LLmsModel.isAllowLLMChange,
        flowGroupID: this.LLmsModel.flowGroupID,
        CategoryID: this.getSaveModelCategoryId(),
      };
    },
    shouldConfirmPlaygroundApiVersion(actions) {
      return this.isApiVersionMissing() && this.page.includes('Playground') && actions !== 'playground-confirmed';
    },
    confirmPlaygroundApiVersion() {
      this.$swal.fire({
        icon: 'warning',
        title: this.$t('warning'),
        text: this.$t('warningAPIVersion'),
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('close'),
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.Save('playground-confirmed');
        }
      });
    },
    normalizeSaveFields() {
      this.LLmsModel.frequencyPenalty = this.LLmsModel.frequencyPenalty == '' ? null : this.LLmsModel.frequencyPenalty;
      this.LLmsModel.presencePenalty = this.LLmsModel.presencePenalty == '' ? null : this.LLmsModel.presencePenalty;
      this.LLmsModel.topVDB = this.LLmsModel.topVDB == '' ? null : this.LLmsModel.topVDB;
      this.LLmsModel.productTopVDB = this.LLmsModel.productTopVDB == '' ? null : this.LLmsModel.productTopVDB;
      this.LLmsModel.IsLongTerm_Memory = this.LLmsModel.provider == 'Google' ? false : (this.LLmsModel.IsLongTerm_Memory ?? false);
      this.LLmsModel.typingSpeed = Number.parseInt(this.LLmsModel.typingSpeed);
      this.LLmsModel.maximumChatInput = Number.parseInt(this.LLmsModel.maximumChatInput);
    },
    handleSaveSuccess(dataResponse, actions) {
      if (dataResponse.status == 0) {
        let msgSuccess = this.page == 'Edit Model' || this.localEditAction ? '✔ ' + this.$t('successfullyUpdated') : '✔ ' + this.$t('successfullyCreated');
        this.$swal.fire({
          title: msgSuccess,
          showConfirmButton: false,
          timer: 1500,
          position: 'top',
          background: 'transparent',
          customClass: {
            popup: 'success-banner',
            title: 'success-banner-title',
          },
          backdrop: false, // **สำคัญ ถ้าไม่ต้องการบัง UI**
        });

        if (this.page.includes('Playground')) {
          this.$emit('is-event', {
            type: 'PlaygroundSaved',
            id: dataResponse.data,
            side: this.LLmsModel.side,
          });
        } else if (actions == 's&c') this.$router.push('/GPTModelManagement');
        else {
          this.$router
            .push({
              name: 'GPTModelDetail',
              query: {
                id: dataResponse.data,
              },
            })
            .then(() => {
              this.Get(dataResponse.data);
            });
        }
      }
      if (dataResponse.status == 1 && dataResponse.data.is_exist) {
        this.$swal.fire({
          icon: 'error',
          title: this.$t('modelIdExist'),
          showConfirmButton: false,
          timer: 1800,
        });
      }
      this.saveLoading = false;
      this.dialog = false;
    },
    async Save(actions) {
      // guard ให้ตรงกับ :disabled ของปุ่ม
      if (this.isSaveDisabled) {
        return;
      }
      this.clearRequiredWarning();
      if (this.validateMaxToken()) {
        return;
      }
      const incompleteFields = this.getIncompleteInformationFields();
      if (incompleteFields.length > 0) {
        const parameterLabels = [this.$t('temperature'), this.$t('topP')];
        const onlyParameterIssues = incompleteFields.every((field) => parameterLabels.includes(field));
        // ติดแค่ Temperature/Top P ไม่ต้องเด้ง dialog (dialog ของ Vuetify ล็อค scroll ทำให้เลื่อนไม่ได้)
        // เลื่อนไปที่ช่องที่ขึ้นแดงให้เลย ส่วนกรณีขาดฟิลด์อื่นด้วยยังต้องบอกว่าขาดอะไรบ้าง
        if (onlyParameterIssues) {
          this.scrollToParameters();
        } else {
          this.setRequiredWarning(incompleteFields);
        }
        return;
      }

      const modelData = this.getSaveModelData();
      if (this.shouldConfirmPlaygroundApiVersion(actions)) {
        this.confirmPlaygroundApiVersion();
        return;
      }
      if (typeof this.validatePrompt(this.LLmsModel.promptTemplate) == 'string') {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.$t('_pleaseEnterCorrectFormat'),
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      this.dialog = true;
      try {
        this.saveLoading = true;
        this.normalizeSaveFields();
        this.$call.AddGPTModel(
          modelData,
          (dataResponse) => {
            this.handleSaveSuccess(dataResponse, actions);
          },
          (errorResource) => {
            this.dialog = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    async Edit(item) {
      if (this.page === 'Model Creator') {
        this.localEditAction = null;
      } else {
        this.localEditAction = true;
      }
      this.GPTModel_isPublish = item.isPublish;
      this.LLmsModel.modelId = item.modelID;
      this.LLmsModel.modelName = item.modelName;
      this.LLmsModel.provider = item.provider;
      this.LLmsModel.model = this.buildModelSelectionValue(item.model, item.modelNameDisplay);
      this.LLmsModel.APIVersion = item.apiVersion;
      this.LLmsModel.extension = item.extension;
      this.LLmsModel.description = item.description;
      this.LLmsModel.promptTemplate = item.promptTemplate;
      this.LLmsModel.gender = item.gender;
      this.LLmsModel.vectordbName = item.vectordbName;
      this.LLmsModel.groupReplaceID = item.groupReplaceID;
      this.LLmsModel.knowledgeGraphKeys = item.knowledgeGraphKeys ?? [];
      // config ที่ไม่เคยตั้งมาเป็น null — เติม default ให้ครบทุกช่องก่อน merge ค่าที่บันทึกไว้
      this.LLmsModel.kgRetrievalConfig = { ...KG_RETRIEVAL_DEFAULTS, ...(item.kgRetrievalConfig || {}) };
      this.LLmsModel.productGroupID = item.productGroupID ?? [];
      this.LLmsModel.topVDB = item.topVDB;
      this.LLmsModel.productTopVDB = item.productTopVDB;
      this.LLmsModel.productCosine = item.productCosine;
      this.LLmsModel.internet = item.internet;
      this.LLmsModel.feedback = item.feedback;
      this.LLmsModel.historyCount = item.historyCount;
      this.LLmsModel.historyMinute = item.historyMinute < 0 ? Math.abs(item.historyMinute) : item.historyMinute;
      this.LLmsModel.temperature = item.temperature;
      this.LLmsModel.topP = item.top_p;
      this.clearParameterError('temperature');
      this.clearParameterError('topP');
      this.LLmsModel.frequencyPenalty = item.frequency_penalty;
      this.LLmsModel.presencePenalty = item.presence_penalty;
      this.LLmsModel.stop = item.stop;
      this.LLmsModel.maxTokens = item.max_tokens;
      this.LLmsModel.llmTimeout = item.llmTimeout ?? null;
      this.LLmsModel.isStream = item.isStream;
      this.LLmsModel.isBypass = item.isBypass;
      this.LLmsModel.isFeedback = item.isFeedback;
      this.LLmsModel.isAllowImage = item.isAllowImage;
      this.LLmsModel.fileUploadLimit = item.fileUploadLimit == null ? item.fileUploadLimit : Number.parseInt(item.fileUploadLimit);
      this.LLmsModel.versioning = item.versioning;
      const resolvedIsPublish = item.isPublish == null ? false : item.isPublish;
      this.LLmsModel.isPublish = this.page == 'view model' ? resolvedIsPublish : item.isPublish;
      this.LLmsModel.modelIDGroup = item.modelIDGroup;
      this.LLmsModel.modelDisplay = item.modelDisplay;
      this.LLmsModel.Len_ShortMemory = item.len_ShortMemory ?? 200;
      this.LLmsModel.IsLongTerm_Memory = this.LLmsModel.provider == 'Google' ? false : (item.isLongTerm_Memory ?? false);
      this.LLmsModel.IsChainMassage = item.isChainMassage ?? false;
      this.LLmsModel.LenChainMassage = item.lenChainMassage;
      this.LLmsModel.TimeSecondChainMassage = item.timeSecondChainMassage;
      this.LLmsModel.Cosine = item.cosine;
      this.LLmsModel.DataIntegrationID = item.dataIntegrationID;
      this.LLmsModel.SqlModelID = item.sqlModelID;
      this.LLmsModel.promptSqlNoData = item.promptSqlNoData;
      this.LLmsModel.IntentGroupID = item.intentGroupID;
      this.LLmsModel.typingSpeed = Number.parseInt(item.typingSpeed);
      this.LLmsModel.maximumChatInput = item.maximumChatInput == null ? MAX_CHAT_INPUT_LIMIT : Number.parseInt(item.maximumChatInput);
      this.LLmsModel.loadingBarFlag = item.loadingBarFlag;
      this.LLmsModel.loadingBarDuration = item.loadingBarDuration;
      this.LLmsModel.forbiddenWord = this.forbiddenWordHandle(item.forbiddenWord) ?? [''];
      this.LLmsModel.monitorLineUserID = item.monitorLineUserID;
      this.LLmsModel.isShowNameUserMonitor = item.isShowNameUserMonitor;
      this.LLmsModel.monitorSocialID = item.monitorSocialID;
      this.LLmsModel.typeLLM = item.typeLLM == 'GuardRail' ? 1 : 0;
      this.LLmsModel.guardRailModelID = item.guardRailModelID;
      this.LLmsModel.modelType = item.modelType;
      this.LLmsModel.styleImage = item.styleImage;
      this.LLmsModel.resFormatImage = item.resFormatImage;
      this.LLmsModel.quality = item.quality;
      this.LLmsModel.resolution = item.resolution;
      this.LLmsModel.jsonRequest = item.jsonRequest;
      this.LLmsModel.enableTime = Boolean(item.timeZone);
      this.LLmsModel.timeZone = item.timeZone;
      this.LLmsModel.reasoningEffort = item.reasoningEffort;
      this.LLmsModel.endPointURL = item.endPointURL;
      this.LLmsModel.apI_Key = item.apI_Key;
      this.LLmsModel.authenHeaderName = item.authenHeaderName;
      this.LLmsModel.platform = item.platform;
      this.EditdialogUser = true;
      this.LLmsModel.isAllowLLMChange = item.isAllowLLMChange;
      this.LLmsModel.flowGroupID = item.flowGroupID;
      this.LLmsModel.categoryName = item.categoryID ? (this.categories.find(c => c.id === item.categoryID)?.name ?? null) : null;
    },
    savePlayground() {
      this.$emit('is-event', 'SaveEdit');
      return true;
    },
    closePlayground() {
      this.$emit('is-event', 'Close');
    },
    isBlank(value) {
      return value == null || String(value).trim() == '';
    },
    setRequiredWarning(fields = []) {
      this.requiredMissingFields = [...new Set(fields.filter(Boolean))];
      this.showNameRequiredDialog = true;
    },
    clearRequiredWarning() {
      this.requiredMissingFields = [];
      this.showNameRequiredDialog = false;
    },
    checkValidate() {
      if (this.LLmsModel.vectordbName != null && this.LLmsModel.vectordbName != '') {
        if (this.LLmsModel.topVDB == '' || this.LLmsModel.topVDB == null || Number.parseInt(this.LLmsModel.topVDB) == 0) {
          return 'Required.';
        }
      }
      if (this.LLmsModel.IsChainMassage) {
        if (this.LLmsModel.LenChainMassage == null || this.LLmsModel.LenChainMassage == '' || this.LLmsModel.TimeSecondChainMassage == null || this.LLmsModel.TimeSecondChainMassage == '') {
          return 'Required.';
        }
      }
      return true;
    },
    checkProductValidate() {
      if (this.LLmsModel.productGroupID != null && this.LLmsModel.productGroupID != '') {
        if (this.LLmsModel.productTopVDB == '' || this.LLmsModel.productTopVDB == null || Number.parseInt(this.LLmsModel.productTopVDB) == 0) {
          return 'Required.';
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isPositiveDecimal: function (evt) {
      evt = evt || window.event;
      const key = evt.key;

      if (!key || key.length !== 1) {
        return true;
      }

      if (key >= '0' && key <= '9') {
        return true;
      }

      if (key !== '.') {
        evt.preventDefault();
        return false;
      }

      const inputValue = evt.target?.value?.toString() ?? '';
      const selectionStart = evt.target?.selectionStart ?? inputValue.length;
      const selectionEnd = evt.target?.selectionEnd ?? inputValue.length;
      const nextValue = inputValue.substring(0, selectionStart) + key + inputValue.substring(selectionEnd);

      if ((nextValue.match(/\./g) || []).length > 1) {
        evt.preventDefault();
        return false;
      }

      return true;
    },
    limitNumberKeypress(evt, maxLen, maxValue) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;

      if (selectionStart === selectionEnd) {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      } else {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > maxLen || // Check if the length exceeds the limit
        Number.parseInt(newValue) > maxValue // Check if the number exceeds the limit
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    maxNumberpositive: function (evt) {
      // input[type=number] ไม่รองรับ selection API (selectionStart/End เป็น null)
      // จึงบล็อกแค่คีย์ที่ไม่ใช่ตัวเลข แล้วไปจำกัดช่วงค่าที่ clampMaximumChatInput() ตอน blur แทน
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
        return false;
      }
      return true;
    },
    clampMaximumChatInput() {
      const value = Number.parseInt(this.LLmsModel.maximumChatInput, 10);
      if (Number.isNaN(value)) {
        // ปล่อยให้ว่างไว้ เพื่อให้ required validation ตอนบันทึกทำงานตามเดิม
        return;
      }
      this.LLmsModel.maximumChatInput = Math.min(Math.max(value, 0), MAX_CHAT_INPUT_LIMIT);
    },
    validateNumber: function (evt) {
      return this.limitNumberKeypress(evt, 5, 20000);
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return inputValue.length <= this.maxLengthChar || this.$t('_validateMaxChar', { max: this.convertNumberToStringFormat(this.maxLengthChar) });
      }
    },
    // Top P ถูก disable เมื่อ provider = Anthropic (ดู :disabled ของ topP-field-modelmanagement)
    // ช่องที่ผู้ใช้กรอกไม่ได้จึงไม่นับว่า 'ไม่ได้ config' ไม่งั้นโมเดล Anthropic จะ save ไม่ได้เลย
    // ข้อความสั้นใต้ช่อง บอกทั้งว่าใช้ไม่ได้และต้องเปลี่ยนเป็นค่าอะไร
    // (รายละเอียดเต็มอยู่ในแถบสถานะของหัวข้อ Parameters)
    probeFieldMessage(key) {
      const value = this.modelProbe.suggestion ? this.modelProbe.suggestion[key] : null;
      return value === null || value === undefined
        ? this.$t('_probeFieldRejectedNoValue')
        : this.$t('_probeFieldRejected', { value });
    },
    formatProbeValue(value) {
      return value === null || value === undefined ? '-' : String(value);
    },
    toProbeNumber(value) {
      if (value === '' || value == null) return null;
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : null;
    },
    buildProbeModelConfig(overrides = {}) {
      const selected = this.findModelDefinition(this.LLmsModel.model, this.DDModelShow) || this.findModelDefinition(this.LLmsModel.model);
      return {
        platform: this.LLmsModel.platform,
        provider: this.LLmsModel.provider,
        // ต้องส่งรูปแบบ 'ModelName|ModelDisplay' ตรง ๆ เพราะ BuildGPTModelAsync (LLMUtilityBAL.cs:173)
        // หา ModelData ด้วย m.ModelName ซึ่ง GetDDLModelData คืนมาเป็นรูปแบบมี pipe เสมอ (ModelDataBAL.cs:224)
        // ถ้า normalize ทิ้ง pipe จะหา row ไม่เจอ -> JsonRequest เป็น null -> ยิงผิดฟอร์แมตและ fail ทุกรอบ
        model: selected?.modelName || this.LLmsModel.model,
        apiVersion: this.getApiVersionForSave(),
        temperature: overrides.temperature ?? this.toProbeNumber(this.LLmsModel.temperature),
        topP: overrides.topP ?? this.toProbeNumber(this.LLmsModel.topP),
        maxTokens: this.toProbeNumber(this.LLmsModel.maxTokens) ?? this.totalTokens ?? null,
        frequencyPenalty: this.toProbeNumber(this.LLmsModel.frequencyPenalty) ?? 0,
        presencePenalty: this.toProbeNumber(this.LLmsModel.presencePenalty) ?? 0,
        stop: null,
        reasoningEffort: this.getSaveModelReasoningEffort(),
        jsonResponse: false,
      };
    },
    buildProbeFingerprint(overrides = {}) {
      const config = this.buildProbeModelConfig(overrides);
      return JSON.stringify([config.platform, config.provider, config.model, config.apiVersion, config.temperature, config.topP, config.maxTokens, config.reasoningEffort, this.LLmsModel.jsonRequest || null]);
    },
    // ระบบตอบข้อความ fallback (เช่น 'ขออภัย ไม่สามารถตอบคำถามนี้ได้ [2]') หรือตอบว่าง = ถือว่าเรียกไม่สำเร็จ
    isLlmAlertReply(text) {
      const value = (text || '').trim();
      if (!value) return true;
      return /ไม่สามารถตอบคำถามนี้ได้\s*\[\d+\]/.test(value);
    },
    probeModelOnce(config) {
      return new Promise((resolve) => {
        // กันกรณี request แขวน ไม่งั้น status ค้างที่ running แล้วปุ่ม Save จะเทาถาวร
        let settled = false;
        const finish = (result) => {
          if (settled) return;
          settled = true;
          clearTimeout(timeoutId);
          resolve(result);
        };
        const timeoutId = setTimeout(() => finish({ ok: false, detail: '' }), PROBE_TIMEOUT_MS);

        this.$call.TestAIModelPrompt(
          // skipLog: probe นี้เป็นแค่การตรวจค่า config ไม่ต้องไปโผล่ใน chat log
          { userMessage: 'ping', systemMessage: '', modelConfig: config, skipLog: true },
          (response) => {
            const data = response?.data || response?.Data;
            const status = response?.status ?? response?.Status;
            if (status !== 0 || !data) {
              finish({ ok: false, detail: response?.message || response?.Message || '' });
              return;
            }
            const detail = data.errorDetail || data.ErrorDetail || '';
            const text = data.responseText || data.ResponseText || '';
            if (detail || this.isLlmAlertReply(text)) {
              finish({ ok: false, detail: detail || text });
              return;
            }
            finish({ ok: true, detail: '' });
          },
          (err) => finish({ ok: false, detail: err?.response?.data?.message || err?.message || '' })
        );
      });
    },
    // shortmemory มาในรูป '<status> | reason:<message> #-# <memory>' เอาเฉพาะส่วน reason
    formatProbeDetail(detail) {
      if (!detail) return '';
      const reasonMatch = /reason:([^#]*)/i.exec(detail);
      const text = (reasonMatch ? reasonMatch[1] : detail).trim();
      // ข้อความ fallback ของระบบ ('...[2]') ไม่ได้บอกสาเหตุอะไร ไม่ต้องเอามาแสดงให้ผู้ใช้งง
      if (this.isLlmAlertReply(text)) return '';
      return text.slice(0, 300);
    },
    // guard ให้ตรงกับ :disabled ของปุ่มทดสอบ
    onClickTestModel() {
      if (!this.canRunModelProbe) return;
      this.runModelProbe();
    },
    // ยิงทดสอบกับโมเดลจริง แล้วแยกแยะว่าที่พังเป็นเพราะ temperature/top_p หรือเรื่องอื่น
    // วิธีแยก: ถ้าเปลี่ยนแค่ temperature/top_p เป็น 1 แล้วผ่าน แปลว่าสาเหตุคือสองค่านี้
    // กดปุ่มแล้วยิงจริงทุกครั้ง ไม่ใช้ cache (ผลเก่าอาจมาจาก network/timeout ชั่วคราว)
    async runModelProbe() {
      if (this.isBlank(this.LLmsModel.model) || this.isBlank(this.LLmsModel.platform)) {
        return;
      }

      const fingerprint = this.buildProbeFingerprint();
      this.modelProbe.status = 'running';
      this.modelProbe.message = '';
      this.modelProbe.suggestion = null;

      const current = await this.probeModelOnce(this.buildProbeModelConfig());
      let outcome;

      const checked = {
        temperature: this.toProbeNumber(this.LLmsModel.temperature),
        topP: this.toProbeNumber(this.LLmsModel.topP),
        model: this.selectedModelInfo?.modelDisplay || this.LLmsModel.model,
      };

      if (current.ok) {
        outcome = { status: 'ok', message: '', suggestion: null, checked };
      } else {
        const suggestion = { temperature: 1, topP: 1 };
        const fallback = await this.probeModelOnce(this.buildProbeModelConfig(suggestion));
        if (fallback.ok) {
          // ค่าที่แนะนำทดสอบผ่านแล้ว กด 'ใช้ค่าที่แนะนำ' จะได้ผ่านทันทีโดยไม่ต้องกดทดสอบซ้ำ
          this.probeCache[this.buildProbeFingerprint(suggestion)] = {
            status: 'ok',
            message: '',
            suggestion: null,
            checked: { ...checked, temperature: suggestion.temperature, topP: suggestion.topP },
          };
          outcome = {
            status: 'invalid-sampling',
            message: this.$t('_probeSamplingRejected', {
              current: this.formatProbeValue(checked.temperature),
              currentTopP: this.formatProbeValue(checked.topP),
              temperature: suggestion.temperature,
              topP: suggestion.topP,
            }),
            suggestion,
            checked,
          };
        } else {
          const detail = this.formatProbeDetail(current.detail);
          outcome = {
            status: 'failed',
            message: detail ? this.$t('_probeFailed') + ' ' + detail : this.$t('_probeFailedNoDetail'),
            suggestion: null,
            checked,
          };
        }
      }

      this.probeCache[fingerprint] = outcome;
      // ผู้ใช้แก้ค่าระหว่างรอผล: ผลนี้เป็นของค่าชุดเก่า ไม่เอามาแสดงกับค่าบนจอ
      const currentFingerprint = this.buildProbeFingerprint();
      if (currentFingerprint !== fingerprint) {
        this.restoreProbeOutcome(currentFingerprint);
        return;
      }
      this.applyProbeOutcome(outcome, fingerprint);
    },
    // แสดงผลทดสอบของค่าชุดนี้ถ้าเคยทดสอบไว้ ไม่งั้นกลับเป็น 'ยังไม่ได้ทดสอบ'
    restoreProbeOutcome(fingerprint) {
      if (this.probeCache[fingerprint]) {
        this.applyProbeOutcome(this.probeCache[fingerprint], fingerprint);
        return;
      }
      if (this.modelProbe.status === 'invalid-sampling') {
        this.clearParameterError('temperature');
        this.clearParameterError('topP');
      }
      this.modelProbe.status = 'idle';
      this.modelProbe.message = '';
      this.modelProbe.suggestion = null;
      this.modelProbe.checked = null;
      this.modelProbe.okFingerprint = null;
    },
    applyProbeOutcome(outcome, fingerprint) {
      this.modelProbe.status = outcome.status;
      this.modelProbe.message = outcome.message;
      this.modelProbe.suggestion = outcome.suggestion;
      this.modelProbe.checked = outcome.checked || null;
      this.modelProbe.okFingerprint = outcome.status === 'ok' ? fingerprint : null;

      if (outcome.status === 'invalid-sampling') {
        this.setParameterError('temperature', this.probeFieldMessage('temperature'));
        if (this.isTopPEditable()) {
          this.setParameterError('topP', this.probeFieldMessage('topP'));
        }
      } else if (outcome.status === 'ok') {
        this.clearParameterError('temperature');
        this.clearParameterError('topP');
      }
    },
    // เด้งไปที่ส่วน Parameters ที่ขึ้นแดงไว้ ใช้ตอนกด Save แล้วค่ายังไม่ถูกแก้
    // ส่วน Parameters อยู่ในการ์ด Model Setting ที่ใช้ v-if="modelSettingOpen"
    // ถ้าการ์ดยังไม่ถูกเปิด element จะไม่ถูก render เลย ต้องเปิดก่อนแล้วค่อยเลื่อน
    scrollToParameters() {
      this.modelSettingOpen = true;
      this.highlightParameters();
      this.$nextTick(() => {
        setTimeout(() => {
          const section = document.getElementById('parameters-section-modelmanagement');
          if (section && typeof section.scrollIntoView === 'function') {
            section.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 150);
      });
    },
    // กรอบแดงกะพริบรอบส่วน Parameters ให้ผู้ใช้เห็นทันทีว่าต้องแก้ตรงไหน
    highlightParameters() {
      clearTimeout(this.parametersHighlightTimer);
      this.parametersHighlight = true;
      this.parametersHighlightTimer = setTimeout(() => {
        this.parametersHighlight = false;
      }, 4000);
    },
    applyDefaultSampling() {
      const defaults = getDefaultSampling(this.selectedModelNames);
      this.LLmsModel.temperature = defaults.temperature;
      this.clearParameterError('temperature');
      if (this.isTopPEditable()) {
        this.LLmsModel.topP = defaults.topP;
        this.clearParameterError('topP');
      }
    },
    // ตั้ง temperature / top p ตาม rule 'fixed' ของ model ที่เลือก (เฉพาะช่องที่ค่าถูกส่งไปจริง)
    applySamplingRule() {
      for (const violation of this.samplingRuleViolations) {
        this.LLmsModel[violation.key] = violation.expected;
        this.clearParameterError(violation.key);
      }
    },
    // ข้อความ error ของช่อง Temperature / Top P: error ที่ตั้งจาก validation/ผลทดสอบมาก่อน
    // ถ้าไม่มีค่อยดู rule (คำนวณสด จึงขึ้นแดงทันทีที่พิมพ์ค่าที่ใช้ไม่ได้)
    parameterFieldError(key) {
      if (this.error[key]?.error) return this.error[key].message;
      const violation = this.samplingRuleViolations.find((item) => item.key === key);
      return violation ? this.$t('_probeFieldRejected', { value: violation.expected }) : '';
    },
    // ค่าที่เปลี่ยนจะไปเข้า watcher currentProbeFingerprint ซึ่งดึงผลที่ทดสอบไว้แล้วจาก cache
    applyProbeSuggestion() {
      if (!this.modelProbe.suggestion) return;
      this.LLmsModel.temperature = this.modelProbe.suggestion.temperature;
      if (this.isTopPEditable()) {
        this.LLmsModel.topP = this.modelProbe.suggestion.topP;
      }
      this.clearParameterError('temperature');
      this.clearParameterError('topP');
    },
    isTopPEditable() {
      return this.LLmsModel.provider != 'Anthropic';
    },
    validateTopPInput(inputValue) {
      return this.isTopPEditable() ? this.validateInput0_1(inputValue) : true;
    },
    isOutOfRange0_1(value) {
      const parsed = Number.parseFloat(value);
      return Number.isNaN(parsed) || parsed < 0 || parsed > 1;
    },
    setParameterError(key, message) {
      if (!this.error?.[key]) return;
      this.error[key].error = true;
      this.error[key].message = message;
    },
    clearParameterError(key) {
      if (!this.error?.[key]) return;
      this.error[key].error = false;
      this.error[key].message = '';
    },
    // ตั้ง error state ให้ช่อง Temperature / Top P (กรอบ + ข้อความสีแดงที่ช่อง)
    // แล้วคืน label ของช่องที่ยังไม่ผ่าน ให้ dialog รวมแสดงต่อ
    validateParameterFields() {
      const missingFields = [];

      this.clearParameterError('temperature');
      this.clearParameterError('topP');

      const checks = [
        { key: 'temperature', label: this.$t('temperature'), value: this.LLmsModel.temperature, enabled: true },
        { key: 'topP', label: this.$t('topP'), value: this.LLmsModel.topP, enabled: this.isTopPEditable() },
      ];

      for (const check of checks) {
        if (!check.enabled) continue;

        if (this.isBlank(check.value)) {
          this.setParameterError(check.key, this.$t('requiredField'));
          missingFields.push(check.label);
        } else if (this.isOutOfRange0_1(check.value)) {
          this.setParameterError(check.key, this.$t('_validateNum0to1'));
          missingFields.push(check.label);
        }
      }

      // ค่าขัดกับ rule 'fixed' ของตระกูลโมเดล = รู้แน่ว่าเรียกไม่สำเร็จ save ไม่ได้
      // (ข้อความสีแดงที่ช่องมาจาก parameterFieldError และแก้ได้ด้วยปุ่ม 'ใช้ค่าที่แนะนำ')
      for (const violation of this.samplingRuleViolations) {
        missingFields.push(violation.key === 'temperature' ? this.$t('temperature') : this.$t('topP'));
      }

      // โมเดลปฏิเสธค่า sampling ที่ตั้งไว้ (ยืนยันด้วยการทดสอบจริง) = save ไม่ได้
      if (this.modelProbe.status === 'invalid-sampling') {
        this.setParameterError('temperature', this.probeFieldMessage('temperature'));
        missingFields.push(this.$t('temperature'));
        if (this.isTopPEditable()) {
          this.setParameterError('topP', this.probeFieldMessage('topP'));
          missingFields.push(this.$t('topP'));
        }
      }

      return missingFields;
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return this.$t('requiredField');
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || this.$t('_validateNum0to1');
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = Number.parseFloat(inputValue);
      if (Number.isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || this.$t('_validateNum0to2');
    },
    validateMaxToken() {
      this.error.maxTokens.error = false;
      this.error.maxTokens.message = '';
      if (this.LLmsModel.maxTokens > this.totalTokens && this.totalTokens != null) {
        this.error.maxTokens.error = true;
        this.error.maxTokens.message = this.$t('_maxTokensExceed', { total: this.totalTokens });
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.error.maxTokens.message,
          showConfirmButton: false,
          timer: 3000,
          backdrop: false,
        });
        return true;
      }
      return false;
    },
    validateLlmTimeout() {
      const timeoutValue = this.LLmsModel.llmTimeout;

      if (timeoutValue == null || timeoutValue === '') {
        return false;
      }

      const parsedTimeout = Number(timeoutValue);
      return !Number.isFinite(parsedTimeout) || parsedTimeout < 1 || parsedTimeout > 3600;
    },
    getIncompleteInformationFields() {
      const missingFields = [];
      const addIfMissing = (label, condition) => {
        if (condition) {
          missingFields.push(label);
        }
      };

      addIfMissing(this.$t('imageStyle'), this.txtToImgChecker && this.isBlank(this.LLmsModel.styleImage));
      addIfMissing(this.$t('timeZone'), this.LLmsModel.enableTime === true && this.isBlank(this.LLmsModel.timeZone));
      addIfMissing(this.$t('modelType'), this.LLmsModel.typeLLM === undefined || this.LLmsModel.typeLLM === null);
      addIfMissing(this.$t('modelName'), this.isBlank(this.LLmsModel.modelName));
      addIfMissing(this.$t('model'), this.isBlank(this.LLmsModel.platform) || this.isBlank(this.LLmsModel.provider) || this.isBlank(this.LLmsModel.model));
      addIfMissing(this.$t('publicationControl'), this.LLmsModel.isPublish == null);

      if (this.LLmsModel.IsChainMassage === true) {
        addIfMissing(this.$t('sequence'), this.isBlank(this.LLmsModel.LenChainMassage));
        addIfMissing(this.$t('durationSeconds'), this.isBlank(this.LLmsModel.TimeSecondChainMassage));
      }

      // Temperature / Top P: ทำเครื่องหมายสีแดงที่ช่องด้วย ไม่ใช่แค่ลิสต์ใน dialog รวม
      for (const label of this.validateParameterFields()) {
        addIfMissing(label, true);
      }
      addIfMissing(this.$t('maxInputLength'), this.LLmsModel.maximumChatInput == null || this.LLmsModel.maximumChatInput === '' || this.LLmsModel.maximumChatInput < 0);
      addIfMissing(this.$t('topNChunk'), this.LLmsModel.topVDB == null && this.LLmsModel.vectordbName?.length > 0);
      addIfMissing(this.$t('productTopNChunk'), this.LLmsModel.productTopVDB == null && this.LLmsModel.productGroupID?.length > 0);
      addIfMissing(this.$t('apiVersion'), !this.page.includes('Playground') && this.isApiVersionMissing());
      addIfMissing(this.$t('timeoutResponse'), this.validateLlmTimeout());

      return [...new Set(missingFields)];
    },
    convertNumberToStringFormat(value) {
      const [intPart, decPart] = value.toString().split('.');
      const grouped = intPart.split('').reverse().join('').replace(/(\d{3})(?=\d)/g, '$1,').split('').reverse().join('');
      return decPart !== undefined ? `${grouped}.${decPart}` : grouped;
    },
    normalizeModelValue(value) {
      if (typeof value !== 'string') {
        return value;
      }

      const trimmedValue = value.trim();
      if (!trimmedValue.includes('|')) {
        return trimmedValue;
      }

      const parts = trimmedValue.split('|');
      const model = (parts.shift() || '').trim();
      const modelNameDisplay = parts.join('|').trim();

      if (!modelNameDisplay || model === modelNameDisplay) {
        return model;
      }

      return `${model}|${modelNameDisplay}`;
    },
    customFilter(fn, listData) {
      const f = [];
      for (const item of listData) {
        if (fn(item)) {
          f.push(item);
        }
      }
      return f;
    },
    async changePlatform(value, options = {}) {
      const preserveModel = options.preserveModel === true;
      const fixedProvider = this.getFixedProviderByPlatform(value);

      if (!value) {
        this.LLmsModel.provider = null;
        this.DDModelShow = [];
        this.resetModelSelection();
        return 'Required.';
      }

      if (fixedProvider) {
        this.LLmsModel.provider = fixedProvider;
        await this.changeProvider(fixedProvider, { preserveModel });
        return true;
      }

      const hasCurrentProvider = this.availableProviders.some((provider) => provider.providerName === this.LLmsModel.provider);
      if (!hasCurrentProvider) {
        this.LLmsModel.provider = null;
        this.DDModelShow = [];
        this.resetModelSelection();
        return true;
      }

      await this.changeProvider(this.LLmsModel.provider, { preserveModel });
      return true;
    },
    async changeProvider(value, options = {}) {
      const preserveModel = options.preserveModel === true;

      if (!this.LLmsModel.platform) {
        this.LLmsModel.provider = null;
        this.DDModelShow = [];
        this.resetModelSelection();
        return 'Please select platform first.';
      }

      if (value == null || value == '') {
        this.DDModelShow = [];
        this.resetModelSelection();
        return 'Required.';
      }

      this.DDModelShow = this.getModelsForSelection(value, this.LLmsModel.platform);

      const hasCurrentModel = Boolean(this.findModelDefinition(this.LLmsModel.model, this.DDModelShow));
      if (!preserveModel || !hasCurrentModel) {
        this.resetModelSelection();
      }

      return true;
    },
    clearLLM() {
      this.resetModelSelection();
    },
    getModelMaxLength(modelName) {
      if (modelName == 'gpt-35-turbo') {
        return 4000;
      }
      if (modelName == 'gpt-35-turbo-16k') {
        return 8000;
      }
      return modelName == 'gpt-4' ? 6000 : null;
    },
    applyImageModelSettings(model) {
      if (this.txtToImgChecker) {
        this.LLmsModel.quality = model.quality;
        this.LLmsModel.resolution = model.resolution;
        this.LLmsModel.resFormatImage = model.resFormatImage;
        return;
      }

      this.LLmsModel.styleImage = null;
      this.LLmsModel.resFormatImage = null;
      this.LLmsModel.quality = null;
      this.LLmsModel.resolution = null;
    },
    applyReasoningEffortSettings(model) {
      this.showReasoningEffort = model.useReasoningEffort === true;
      if (!this.showReasoningEffort) {
        this.LLmsModel.reasoningEffort = null;
      } else if (!this.LLmsModel.reasoningEffort) {
        this.LLmsModel.reasoningEffort = 'low';
      }
    },
    applyUploadFileSettings(model) {
      if (model.useUploadFile) {
        this.showFileUpload = model.useUploadFile;
        return;
      }

      this.showFileUpload = false;
      this.LLmsModel.isAllowImage = false;
      this.LLmsModel.fileUploadLimit = null;
    },
    applySelectedModelSettings(model) {
      this.LLmsModel.model = model.modelName;
      this.totalTokens = model.maxToken;
      this.txtToImgChecker = model.modelType == 'text_to_image';
      this.maxLengthChar = this.getModelMaxLength(this.getModelValueParts(model.modelName).model);
      this.applyImageModelSettings(model);
      this.LLmsModel.APIVersion = this.requiresApiVersion(model.platform, model.provider) ? model.apiVersion : null;
      this.LLmsModel.modelType = model.modelType;
      this.LLmsModel.jsonRequest = model.jsonRequest;
      this.applyReasoningEffortSettings(model);
      this.LLmsModel.endPointURL = model.endPointURL;
      this.LLmsModel.apI_Key = model.apI_Key;
      this.LLmsModel.authenHeaderName = model.authenHeaderName;
      this.LLmsModel.platform = model.platform || null;
      this.LLmsModel.provider = model.provider || null;
      this.applyUploadFileSettings(model);
    },
    async changeModel(value) {
      if (!Array.isArray(this.listDDModel) || this.listDDModel.length === 0) {
        return true;
      }

      const selectedModel = this.findModelDefinition(value, this.modelSelectionOptions);
      if (selectedModel && !selectedModel.useUploadFile) {
        this.LLmsModel.isAllowImage = false;
      }

      if (value == null || value == '' || value.split('')[0] == '|') {
        this.resetModelSelection();
        this.LLmsModel.platform = null;
        this.LLmsModel.provider = null;
        return 'required.';
      }

      let ddm = selectedModel || this.findModelDefinition(value);
      if (!ddm) {
        this.resetModelSelection();
        return true;
      }

      this.applySelectedModelSettings(ddm);
    },
    showPromptTemplate() {
      if (this.DDGroupPromptTemplate.length > 0) {
        this.showPromptTem = !this.showPromptTem;
      } else {
        this.showPromptTem = false;
      }
    },
    showAll() {
      this.dialogShowAll = true;
    },
    forbiddenWordHandle(forbiddenWord) {
      if (!forbiddenWord) {
        return this.LLmsModel.forbiddenWord && this.LLmsModel.forbiddenWord.length ? this.LLmsModel.forbiddenWord : [''];
      }

      try {
        const parsedData = JSON.parse(forbiddenWord);
        return Array.isArray(parsedData) && parsedData.length ? parsedData : [''];
      } catch (error) {
        console.error('Failed to parse forbidden words', error);
        return [''];
      }
    },
    forbiddenWordSaveHandle(inputList) {
      if (!Array.isArray(inputList)) {
        return null;
      }

      const sanitizedList = inputList.map((element) => (element ?? '').trim()).filter((element) => element !== '');

      if (sanitizedList.length === 0) {
        return null;
      }

      return JSON.stringify(sanitizedList);
    },
    selectCategoryFromHeader(categoryName) {
      this.LLmsModel.categoryName = categoryName || null;
      this.categoryMenuOpen = false;
    },
    openAddCategoryDialog() {
      this.newCategoryName = '';
      this.dialog_addCategory = true;
      this.categoryMenuOpen = false;
      this.closeRenameCategoryDialog();
    },
    closeCategoryDialog() {
      this.dialog_addCategory = false;
      this.newCategoryName = '';
    },
    openRenameCategoryDialog(category) {
      this.renameCategoryTarget = category;
      this.renameCategoryName = category.name;
      this.dialog_renameCategory = true;
    },
    closeRenameCategoryDialog() {
      this.dialog_renameCategory = false;
      this.renameCategoryName = '';
      this.renameCategoryTarget = null;
    },
    SaveCategory() {
      const name = this.normalizeCategoryDisplayName(this.newCategoryName);
      if (!name) {
        this.$swal.fire({ icon: 'warning', title: this.$t('categoryNameRequired'), showConfirmButton: true, confirmButtonText: this.$t('ok'), confirmButtonColor: '#FFA726' });
        return;
      }
      const existingCategory = this.findExistingCategory(name);
      if (existingCategory) {
        this.LLmsModel.categoryName = existingCategory.name;
        this.$swal({ icon: 'warning', title: this.$t('duplicate'), text: this.$t('nameAlreadyExists', { name }), timer: 2000, showConfirmButton: false });
        return;
      }
      try {
        if (typeof this.$call.AddGPTModelCategory === 'function') {
          this.$call.AddGPTModelCategory(
            { name },
            (res) => {
              if (res && res.status == 0) {
                const addedCategory = this.normalizeCategoryOption(res.data || { name });
                this.categories = this.dedupeCategories([...(this.categories || []), addedCategory]);
                this.LLmsModel.categoryName = (addedCategory && addedCategory.name) || name;
                this.reloadCategories(this.LLmsModel.categoryName);
                this.closeCategoryDialog();
                this.showSuccessBanner('✔ ' + this.$t('categoryCreatedSuccess', { name }));
                return;
              }

              this.$swal({
                icon: 'warning',
                title: this.$t('duplicate'),
                text: res?.message || this.$t('nameAlreadyExists', { name }),
                timer: 2200,
                showConfirmButton: false,
              });
            },
            () => {
              this.$swal({
                icon: 'error',
                title: this.$t('unableToCreateCategory'),
                text: this.$t('pleaseTryAgain'),
                timer: 2200,
                showConfirmButton: false,
              });
            }
          );
        } else {
          this.categories = this.dedupeCategories([...(this.categories || []), { name }]);
          this.LLmsModel.categoryName = name;
          this.closeCategoryDialog();
        }
      } catch (e) {
        console.error(e);
        // category creation failed; surface generic error feedback below
        this.$swal({
          icon: 'error',
          title: this.$t('unableToCreateCategory'),
          text: this.$t('pleaseTryAgain'),
          timer: 2200,
          showConfirmButton: false,
        });
      }
    },
    RenameCategory() {
      if (!this.renameCategoryTarget?.id) {
        return;
      }

      const name = this.normalizeCategoryDisplayName(this.renameCategoryName);
      if (!name) {
        this.$swal.fire({ icon: 'warning', title: this.$t('categoryNameRequired'), showConfirmButton: true, confirmButtonText: this.$t('ok'), confirmButtonColor: '#FFA726' });
        return;
      }

      const duplicateCategory = this.findCategoryByName(name, this.renameCategoryTarget.id);
      if (duplicateCategory) {
        this.$swal.fire({ icon: 'warning', title: this.$t('duplicate'), text: this.$t('nameAlreadyExists', { name }), timer: 2000, showConfirmButton: false });
        return;
      }

      this.$call.UpdateGPTModelCategory(
        { id: this.renameCategoryTarget.id, name },
        (res) => {
          if (res && res.status == 0) {
            this.categories = this.dedupeCategories((this.categories || []).map((category) => (
              category.id === this.renameCategoryTarget.id ? { ...category, name } : category
            )));
            if (this.normalizeCategoryName(this.LLmsModel.categoryName) === this.normalizeCategoryName(this.renameCategoryTarget.name)) {
              this.LLmsModel.categoryName = name;
            }
            this.reloadCategories(this.LLmsModel.categoryName);
            this.closeRenameCategoryDialog();
            this.showSuccessBanner('✔ ' + this.$t('categoryRenamedSuccess', { name }));
            return;
          }

          this.$swal({ icon: 'warning', title: res?.message || this.$t('duplicateCategoryName'), showConfirmButton: true, confirmButtonText: this.$t('ok'), confirmButtonColor: '#FFA726' });
        },
        () => {
          this.$swal({ icon: 'error', title: this.$t('unableToRenameCategory'), text: this.$t('pleaseTryAgain'), timer: 2200, showConfirmButton: false });
        }
      );
    },
    showSuccessBanner(title, timer = 1500) {
      this.$swal.fire({
        title,
        showConfirmButton: false,
        timer,
        position: 'top',
        background: 'transparent',
        customClass: { popup: 'success-banner', title: 'success-banner-title' },
      });
    },
    deleteCategory(category) {
      this.$swal.fire({
        icon: 'warning',
        title: this.$t('_deleteCategoryConfirm', { name: category.name }),
        text: this.$t('_deleteCategoryWarning'),
        showCancelButton: true,
        confirmButtonText: this.$t('delete'),
        cancelButtonText: this.$t('cancel'),
        confirmButtonColor: '#d33',
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        this.$call.DeleteGPTModelCategory(
          category.id,
          (res) => {
            if (res && res.status == 0) {
              this.categories = this.dedupeCategories((this.categories || []).filter((item) => item.id !== category.id));
              if (this.normalizeCategoryName(this.LLmsModel.categoryName) === this.normalizeCategoryName(category.name)) {
                this.LLmsModel.categoryName = null;
              }
              this.reloadCategories(this.LLmsModel.categoryName);
              if (this.renameCategoryTarget?.id === category.id) {
                this.closeRenameCategoryDialog();
              }
              this.showSuccessBanner('✔ ' + this.$t('categoryDeletedSuccess', { name: category.name }));
              return;
            }

            this.$swal({ icon: 'warning', title: res?.message || this.$t('unableToDeleteCategory'), showConfirmButton: true, confirmButtonText: this.$t('ok'), confirmButtonColor: '#FFA726' });
          },
          () => {
            this.$swal({ icon: 'error', title: this.$t('unableToDeleteCategory'), text: this.$t('pleaseTryAgain'), timer: 2200, showConfirmButton: false });
          }
        );
      });
    },
  },
  async mounted() {
    // พ่ออาจส่ง model มาก่อน mounted โดยไม่ผ่าน watcher — เติม field ของ S13-P1 ให้ครบก่อนใช้
    this.normalizeGraphRagFields();
    await this.GetAllDDModelManagement();
    this.LoadKnowledgeGraphsForPicker();
    if (!this.LLmsModel.reasoningEffort && this.reasonOptions.length > 0) {
      this.LLmsModel.reasoningEffort = this.reasonOptions[0].value;
    }
    // Load categories safely (backend may not have this API yet)
    try {
      if (typeof this.$call.GetGPTModelCategory === 'function') {
        this.$call.GetGPTModelCategory(
          (res) => {
            if (res && res.status == 0) {
              this.categories = this.dedupeCategories(res.data || []);
              this.syncSelectedCategoryName();
            }
          },
          () => { this.categories = []; }
        );
      }
    } catch (e) { console.error(e); /* category API missing/unavailable; fall back to empty list */ this.categories = []; }
  },
};
</script>
<style scoped>
.model-field-error {
  color: #b91c1c;
  font-size: 12px;
  line-height: 1.35;
  margin-top: 2px;
}
.model-field-highlight {
  border-radius: 8px;
  outline: 2px solid #ef4444;
  outline-offset: 4px;
  animation: model-field-pulse 1s ease-in-out 0s 4;
}
@keyframes model-field-pulse {
  0%, 100% { outline-color: rgba(239, 68, 68, 0.95); }
  50% { outline-color: rgba(239, 68, 68, 0.15); }
}
.model-field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
/* สูง 22px ไม่เกิน line-height ของ label (22.4px) — outline สีแบรนด์ + มุม 6px ให้อ่านเป็นปุ่ม ไม่ใช่ status chip แบบ Published */
.model-probe-test-btn {
  display: inline-flex;
  flex: none;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border: 1px solid #f3c4b9;
  border-radius: 6px;
  background: #ffffff;
  color: #c32e0e;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.model-probe-test-btn:hover:not(:disabled) {
  border-color: #f67760;
  background: #fff2f2;
}
.model-probe-test-btn:focus-visible {
  outline: 2px solid #f67760;
  outline-offset: 2px;
}
.model-probe-test-btn:disabled {
  border-color: #e5e7eb;
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}
.model-probe-test-btn--running:disabled {
  border-color: #f3c4b9;
  background: #fff2f2;
  color: #c32e0e;
  cursor: progress;
}
.model-probe-inline {
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-top: 4px;
  min-height: 18px;
}
.model-probe-inline--running { color: #52525b; }
.model-probe-inline--ok { color: #047857; }
.model-probe-inline--invalid-sampling { color: #b91c1c; }
.model-probe-inline--failed { color: #c2410c; }
.model-probe-inline--info { color: #475569; }
.model-probe-inline--warning { color: #b45309; }
.model-probe-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  border-radius: 8px;
  padding: 6px 10px;
  margin-bottom: 4px;
}
.model-probe-status--running { background: #f4f4f5; color: #52525b; }
.model-probe-status--ok { background: #ecfdf5; color: #047857; }
.model-probe-status--invalid-sampling { background: #fef2f2; color: #b91c1c; }
.model-probe-status--failed { background: #fff7ed; color: #c2410c; }
.model-probe-apply {
  margin-left: auto;
  border: 1px solid currentColor;
  border-radius: 999px;
  padding: 2px 12px;
  font-size: 12px;
  white-space: nowrap;
}

/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #ffffff !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #c32e0e !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #c32e0e !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.select-prompt {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  background: #ffffff !important;
}
.select-prompt :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.select-prompt :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.select-prompt :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.knowledge-card {
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  padding: 12px;
  margin-left: 4px;
}
.circle-button-no-data {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #c1c3cb !important;
  padding: 8px !important;
  border-radius: 16px !important;
  gap: 4px !important;
  width: 80px;
  height: 32px !important;
  margin-left: 40px !important;
}
.workflow-panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px !important;
  border-radius: 10px;
  background: linear-gradient(100deg, #fff2f2 0%, #ffded8 100%) !important;
}
.workflow-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-example-section {
  display: flex;
  align-items: center;
  justify-content: center !important;
  border: 1px solid #c32e0e;
  border-radius: 10px;
  gap: 6px;
  padding: 10px;
  width: 100px;
  height: 42px !important;
}
.add-example-section:hover {
  background: rgba(195, 0, 0, 0.1);
}
.footer-btn {
  border-radius: 10px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: #04b439 !important;
  width: 100px;
  height: 42px !important;
}
.footer-btn.save:hover {
  background: rgba(4, 180, 57, 0.75) !important;
}
.footer-btn.save span {
  font-size: 16px;
  color: #ffffff;
}
.label-style {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}

.card2 {
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  padding: 20px 10px !important;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  font-weight: 700;
}

.model-header-title-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.publication-header-controls {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.publication-header-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.model-id-chip {
  margin-left: 12px;
  min-width: 110px;
  max-width: 100%;
  min-height: 20px;
  padding: 10px 16px;
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important;  
  box-shadow: none !important;
}

.model-id-chip__text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.publication-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  width: 100px;
  height: 32px;
  box-shadow: none !important;
}

.publication-label {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.publication-version {
  font-size: 14px;
  font-weight: 600;
  color: #c32e0e;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.v-text-field :deep(label) {
  font-size: 0.9375rem;
}
:deep(.v-text-field .v-input__details) {
  padding-inline: 7px 3px !important;
}

.v-expansion-panel-header {
  padding: 0;
  background-color: transparent !important;
}

:deep(.expan-Pannel) .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
  background-color: transparent !important;
}

.forbidden-btn {
  opacity: 0;
}

.forbidden-btn:hover {
  opacity: 100%;
}

.deep-purple.accent-4 {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}

.image-settings-container {
  border-radius: 4px;
  padding: 16px;
}

.info-icon {
  position: absolute;
  right: -6px;
  top: 0;
}

.image-select {
  width: auto;
}

.info-icon:hover {
  color: #1976d2;
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.753) !important;
}

.v-col {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.v-card {
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none;
  transition: all 0.2s ease;
}

.v-tab {
  text-transform: none;
  font-weight: 500;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 0;
}

.model-type-toggle {
  width: 100% !important;
  border-radius: 12px;
  gap: 8px;
}

.model-type-btn {
  flex: 1;
  height: 36px !important;
  text-transform: none;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  min-width: 120px !important;
  border-radius: 12px !important;
}

.model-type-card {
  border-radius: 12px;
  border: none !important;
  transition: background 1s ease;
}

.model-input-group {
  align-items: center;
}

.model-input-col {
  display: flex;
  flex-direction: column;
}
.model-input-control :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.model-input-control :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.model-input-control :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 44px !important;
  box-shadow: none !important;
  background: #ffffff !important;
}

.model-input-control :deep(.v-input__details) {
  display: none;
}

.model-input-control :deep(.v-field__input) {
  padding-top: 10px;
}

.custom-vertical-divider {
  width: 1px;
  border-radius: 999px;
  background: #00000039;
  min-height: 60px;
}

@media (max-width: 960px) {
  .vertical-divider-wrapper {
    display: none !important;
  }
}

.model-input-control :deep(.v-field__outline) {
  border-radius: 12px;
  --v-field-border-opacity: 0.4;
}

.model-input-control :deep(.v-field__outline--focused) {
  --v-field-border-opacity: 1;
}

@media (max-width: 960px) {
  .model-input-row {
    gap: 12px;
  }

  .model-input-control :deep(.v-field) {
    min-height: 44px !important;
  }
}

/* Bot button styles */
.v-btn-toggle .v-btn--active {
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important;
  box-shadow: none !important;
  border: none !important;
  color: white !important;
}

/* Make expansion panel background transparent */
:deep(.v-expansion-panels) {
  background-color: transparent !important;
  box-shadow: none !important;
}

/* Make individual expansion panel background transparent */
:deep(.v-expansion-panel) {
  background-color: transparent !important;
}

/* Make expansion panel content background transparent */
:deep(.v-expansion-panel-content) {
  background-color: transparent !important;
}

/* Make expansion panel header background transparent */
:deep(.v-expansion-panel-header) {
  background-color: transparent !important;
}

:deep(.v-expansion-panel)::before {
  box-shadow: none !important;
}

.model-chip {
  padding: 0 50px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.5s ease;
  animation: fadeIn 0.3s ease-in;
}

.model-chip:hover {
  opacity: 1;
}

.model-id {
  color: black;
  margin-left: 4px;
  font-weight: 500;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

.version-badge {
  z-index: 1;
}

.version-text {
  margin-left: -4px;
  font-size: 11px;
  font-weight: 500;
  color: #616161;
  letter-spacing: 0.4px;
}

.modern-panels {
  background: transparent;
  border-radius: 20px;
  padding: 12px;
}

.modern-panels :deep(.v-expansion-panel) {
  background-color: #ffffff !important;
  border-radius: 16px !important;
  margin-bottom: 16px;
  overflow: hidden;
  transition:
    border-color 0.25s ease,
    box-shadow 0.25s ease,
    transform 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel:not(:last-of-type)) {
  margin-bottom: 18px;
}

.modern-panels :deep(.v-expansion-panel--active) {
  border: 1px solid #e5e7eb;
  transform: translateY(-2px);
}

.modern-panels :deep(.v-expansion-panel-title) {
  min-height: auto;
  padding: 18px 24px;
  background: linear-gradient(135deg, #fff2f2 0%, #ffded8 100%);
  transition:
    background-color 0.2s ease,
    padding 0.2s ease;
}

.modern-panels :deep(.v-expansion-panel-title--active) {
  background: transparent;
}

.modern-panels :deep(.v-expansion-panel-text) {
  background: #ffffff;
  padding: 20px 24px 24px;
}

.modern-panels :deep(.v-expansion-panel-title__overlay) {
  background-color: transparent !important;
}

.modern-panels :deep(.v-expansion-panel-title__icon) {
  margin-left: auto;
  color: #9ca3af;
  transition:
    transform 0.25s ease,
    color 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel-title--active .v-expansion-panel-title__icon) {
  color: #ef4444;
  transform: rotate(180deg);
}

.panel-header {
  width: 100%;
  column-gap: 12px;
  color: #1f2937;
}

.panel-header .header {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.workflow-header {
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 4px;
}

.workflow-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.workflow-header__text {
  display: flex;
  flex-direction: column;
}

.workflow-header__text .header {
  font-size: 17px;
}

.workflow-header__subtitle {
  font-size: 13px;
  color: #646464;
}

.workflow-header__title {
  color: #1f2937;
}

@media (max-width: 600px) {
  .workflow-header {
    align-items: flex-start;
  }

  .workflow-header__icon {
    width: 40px;
    height: 40px;
  }

  .workflow-header__subtitle {
    font-size: 12px;
  }
}

.panel-content {
  padding: 22px 0;
  background: linear-gradient(180deg, rgba(249, 250, 251, 0.4) 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 1) 100%);
  border-top: 1px solid #e5e7eb;
}

/* อนิเมชัน */
.transition-swing {
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.prompt-template-container {
  padding: 0.5rem 0;
}

.prompt-textarea {
  font-family: 'Roboto Mono', monospace;
  line-height: 1.5;
  border: none !important;
  box-shadow: none !important;
  padding: 4px !important;
  font-size: 14px;
  min-height: 300px !important;
  margin-top: -32px !important;
}

.prompt-editor-card {
  border: 1px solid #c9c9c9 !important;
  border-radius: 8px;
  margin-top: 12px;
  box-shadow: none !important;
  transition: all 0.2s ease;
  overflow: hidden;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5) !important;
  box-shadow: 0 1px 3px rgba(227, 6, 6, 0.05);
}

.prompt-templates-card {
  border-radius: 8px;
  background-color: #fff2f2;
  transition: all 0.3s ease;
}

.template-list-item {
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.template-list-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.prompt-template-list {
  max-height: 500px;
  overflow-y: auto;
  background-color: transparent;
}

.template-list-all {
  max-height: 400px;
  overflow-y: auto;
}

.rounded-lg {
  border-radius: 8px !important;
}

.v-card__title {
  font-size: 1rem !important;
  padding: 12px 16px !important;
}

.v-card__text {
  padding: 12px 16px !important;
}

.h-100 {
  height: 100%;
}

/* Fix position of tooltips */
:deep(.v-tooltip__content) {
  background-color: rgba(33, 33, 33, 0.95);
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 5px 10px;
}

.options-section {
  padding: 16px 20px;
}

.option-card {
  padding: 5px 16px;
  border-radius: 10px !important;
  background-color: #ededed;
  height: 50px !important;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.on-hover {
  border-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08) !important;
}

.option-header {
  max-width: calc(100% - 70px);
}
/* Card title styling */
.v-card__title.subtitle-1 {
  font-size: 16px !important;
  padding: 14px 20px !important;
  background-color: transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.additional-content {
  min-height: 44px;
}

.upload-limit-field,
.timezone-field {
  min-height: 58px;
}

.status-switch-container {
  border-radius: 8px;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.status-label {
  min-width: 150px;
}

.status-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-toggle {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.toggle-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 90px;
}

.active-btn.draft-btn {
  background-color: #faefe0 !important;
  color: #9c5d00 !important;
  font-weight: 500;
}

.active-btn.publish-btn {
  background-color: #e8f2e8 !important;
  color: #357938 !important;
  font-weight: 500;
}

.enhanced-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.enhanced-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.enhanced-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Selection Display */
.timezone-selection {
  width: 100%;
  padding: 2px 0;
}

.timezone-code {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Dropdown Items */
.timezone-item {
  padding: 12px 16px !important;
  border-radius: 6px;
  margin: 2px 8px;
  transition: all 0.2s ease;
}

.timezone-item:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.timezone-item-content {
  width: 100%;
}

.timezone-country {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;
}

.timezone-details {
  gap: 8px;
}

/* Avatar styling */
.timezone-item :deep(.v-avatar) {
  margin-right: 12px;
}

/* Dropdown styling */
.enhanced-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.enhanced-select :deep(.v-list) {
  padding: 8px 0 !important;
  background-color: white;
}

/* Icon animations */
.timezone-item :deep(.v-icon) {
  transition: all 0.2s ease;
}

.timezone-item:hover :deep(.v-icon) {
  transform: scale(1.1);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .timezone-selection {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .timezone-code {
    margin-left: 0 !important;
    margin-top: 4px !important;
  }
}

.reasoning-chip {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  min-width: 120px;
  height: 28px !important;
}

.reasoning-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
  font-weight: 500;
  padding: 0 8px !important;
  line-height: 2 !important;
}

.reasoning-chip :deep(.v-chip__underlay) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Image Generation Settings Styling */
.image-settings-card {
  border: 1px solid #c9c9c9 !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.setting-group {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  height: 100%;
}

.setting-group:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
}

/* Enhanced Select Styling */
.style-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  background: white;
}

.style-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
  border-color: rgba(11, 133, 255, 0.829) !important;
}

.style-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
  border-color: rgba(25, 118, 210, 0.8) !important;
}

/* Style Items */
.style-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
}

.style-item:hover {
  background: linear-gradient(135deg, rgba(220, 237, 255, 0.767) 0%, rgba(138, 197, 255, 0.568) 100%);
  transform: translateX(3px);
}

/* Quality and Resolution Fields */
.quality-field :deep(.v-field),
.resolution-field :deep(.v-field) {
  border-radius: 8px !important;
  background: rgba(245, 245, 245, 0.8) !important;
}

.quality-field :deep(.v-field:hover),
.resolution-field :deep(.v-field:hover) {
  background: rgba(240, 240, 240, 0.9) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Animation Improvements */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}

/* Responsive Design */
@media (max-width: 960px) {
  .setting-group {
    margin-bottom: 16px;
  }

  .image-header {
    padding: 16px !important;
  }

  .image-header h3 {
    font-size: 1.1rem !important;
  }
}

/* Dropdown Enhancements */
.style-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.style-select :deep(.v-list) {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.95);
}

/* Chip Enhancements */
.v-chip.v-chip--size-x-small {
  font-size: 10px !important;
  height: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-chip.v-chip--size-small {
  font-size: 11px !important;
  height: 24px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Loading State */
.image-settings-container.loading {
  opacity: 0.7;
  pointer-events: none;
}

.image-settings-container.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 1;
}

.status-wrapper {
  padding: 20px;
}

.status-header {
  margin-bottom: 4px;
}

.status-display-section {
  padding: 8px 0;
}

.status-badge-container {
  margin-bottom: 8px;
}

.status-description {
  display: flex;
  align-items: center;
  opacity: 0.8;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.status-switch {
  transform: scale(1.1);
}

.switch-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 12px !important;
  border: none !important;
  padding: 12px 16px !important;
}

.alert-content {
  line-height: 1.3;
}

/* Switch Styling */
.status-switch :deep(.v-switch__track) {
  width: 48px !important;
  height: 24px !important;
  border-radius: 12px !important;
}

.status-switch :deep(.v-switch__thumb) {
  width: 20px !important;
  height: 20px !important;
  border-radius: 10px !important;
}

/* Avatar animations */
.status-wrapper .v-avatar {
  transition: all 0.3s ease;
}

/* แบบเต็มหน้าจอ */
.publication-status-card-full {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
}

.status-wrapper-full {
  padding: 24px;
}

.status-wrapper-full .v-icon {
  transition: all 0.2s ease;
}

.status-header-full {
  margin-bottom: 8px;
}

.status-chip-large {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 40px !important;
  border-radius: 20px !important;
  display: flex;
  justify-content: center;
  min-width: 150px;
}

.status-content-section {
  margin: 0 -8px;
}

.status-info-card,
.status-control-card {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.model-stats .stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stat-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.stat-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.toggle-container {
  display: flex;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(89, 150, 211, 0.03) 0%, rgba(53, 134, 216, 0.08) 100%);
}

.status-switch-large {
  transform: scale(1.3);
}

.status-switch-active :deep(.v-switch__track) {
  background-color: rgba(76, 175, 79, 0.4) !important;
}

.status-switch-active :deep(.v-switch__thumb) {
  background-color: #4caf50 !important;
  box-shadow: 0px 0px 4px rgba(47, 177, 7, 0.705);
}

.status-switch-inactive :deep(.v-switch__track) {
  box-shadow: 2px 3px 6px rgba(90, 60, 45, 0.582);
  background-color: rgba(255, 153, 0, 0.3) !important;
  border: 1px solid rgba(253, 140, 11, 0.15) !important;
}

.status-switch-inactive :deep(.v-switch__thumb) {
  background-color: #ff9800 !important;
}

.switch-label-container {
  text-align: center;
  min-width: 100px;
  display: flex;
  flex-direction: column;
}

.switch-label-large {
  font-size: 16px;
  font-weight: 600;
  display: block;
  transition: color 0.3s ease;
}

.status-control-card .switch-label-large {
  color: rgba(0, 0, 0, 0.87);
}

.switch-sublabel {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-top: 4px;
}

.publish-card {
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.03) 0%, rgba(var(--v-theme-secondary), 0.01) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.publish-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(var(--v-theme-primary), 0.05), transparent);
  transition: left 0.6s ease;
}
.no-data-message-card {
  padding: 18px 22px;
  border-radius: 16px !important;
  background: linear-gradient(180deg, #ffffff 0%, #fff6f4 100%);
  border: 1px solid rgba(195, 46, 14, 0.2) !important;
  box-shadow: 0 4px 15px rgba(195, 46, 14, 0.08);
}
.no-data-message-content {
  max-width: calc(100% - 140px);
}
.no-data-message-title {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #c32e0e;
  margin-bottom: 6px;
}
.no-data-message-preview {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.85);
  line-height: 1.5;
  max-height: 60px;
  overflow: hidden;
}
.no-data-message-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c32e0e !important;
  border-radius: 12px !important;
  width: 200px;
  height: 48px !important;
  padding: 8px !important;
  gap: 8px;
}
.no-data-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fff8f6 100%);
}
.no-data-dialog-card :deep(.v-card-title) {
  font-weight: 600;
  letter-spacing: 0.3px;
}
.no-data-dialog-card :deep(.v-card-text .v-field) {
  border-radius: 12px !important;
}
.no-data-dialog-card :deep(.v-card-actions) {
  gap: 8px;
}

.memory-section-wrapper {
  margin-bottom: 0px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.memory-card {
  border-radius: 18px !important;
  background: #fff2f2;
  height: 160px;
}

.memory-card__body {
  display: flex;
  column-gap: 24px;
  row-gap: 18px;
  align-items: stretch;
}

.memory-card__short,
.memory-card__long {
  display: flex;
  flex-direction: column;
}

.memory-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.memory-section-header.justify-space-between {
  align-items: center;
}

.memory-icon {
  display: flex;
  align-items: center !important;
  justify-content: start;
  gap: 8px;
}

.memory-title {
  font-size: 16px;
  font-weight: 600;
  color: #171717;
  margin-bottom: 4px;
}

.memory-subtitle {
  font-size: 12px;
  color: rgba(55, 65, 81, 0.65);
}

.memory-status {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.75);
}

.memory-card :deep(.v-field) {
  border-radius: 12px !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 4px 10px rgba(195, 46, 14, 0.05);
}

.memory-card :deep(.v-field:hover) {
  box-shadow: 0 6px 14px rgba(195, 46, 14, 0.08);
}

.memory-card__divider {
  align-self: stretch;
  margin: 0 8px;
  height: 100%;
  border: 1px solid rgba(229, 231, 235, 0.8);
}

.memory-input-row {
  margin-top: -15px;
  padding-left: 10px;
}

.col-label-input {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.multi-turn-section {
  margin-top: 18px;
  border-radius: 16px;
  padding: 18px 0px;
}

.multi-turn-toggle {
  display: flex;
  align-items: center !important;
  justify-content: start;
  gap: 8px;
}

.multi-turn-label {
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  font-size: 14px;
}

.forbidden-container {
  border-radius: 16px;
  padding: 18px;
  background: #ffffff;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.forbidden-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.forbidden-summary__info {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.forbidden-summary__title {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin: 0;
}

.forbidden-summary__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(55, 65, 81, 0.7);
}

.forbidden-summary__count {
  font-size: 13px;
  color: rgba(17, 24, 39, 0.75);
  background: #faeeec;
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 600;
  align-self: center;
}

.forbidden-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(55, 65, 81, 0.65);
  font-size: 13px;
  background: rgba(248, 250, 252, 0.85);
  border-radius: 12px;
  padding: 12px;
  border: 1px dashed rgba(148, 163, 184, 0.6);
}

.forbidden-list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.forbidden-item {
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
}

.forbidden-item:last-child {
  border-bottom: none;
}

.forbidden-index {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8e6e2;
  font-weight: 600;
  color: #c32e0e;
}

.forbidden-input {
  flex: 1;
}

.forbidden-input :deep(.v-field) {
  border-radius: 10px !important;
  background: rgba(248, 250, 252, 0.8) !important;
}

.forbidden-input :deep(.v-field:hover) {
  box-shadow: inset 0 0 0 1px rgba(195, 46, 14, 0.25);
}

.forbidden-delete {
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 12px !important;
}

.forbidden-footer {
  padding-top: 12px;
  display: flex;
  justify-content: flex-start;
}

.forbidden-add-btn {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  padding: 8px;
}
.forbidden-add-btn:hover {
  border-radius: 12px;
  background: #fde4df;
}

.forbidden-fade-enter-active,
.forbidden-fade-leave-active {
  transition: all 0.18s ease;
}

.forbidden-fade-enter-from,
.forbidden-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.multi-turn-section :deep(.v-field) {
  border-radius: 12px !important;
}

@media (max-width: 960px) {
  .memory-card__body {
    flex-direction: column;
  }

  .memory-card__divider {
    display: none;
  }

  .forbidden-item {
    flex-direction: column;
    align-items: stretch;
    row-gap: 10px;
    padding: 14px 0;
  }

  .forbidden-index {
    width: 32px;
    height: 32px;
    align-self: flex-start;
  }

  .forbidden-summary {
    flex-direction: column;
    gap: 12px;
  }

  .forbidden-summary__count {
    align-self: flex-start;
  }
}

@media (max-width: 600px) {
  .memory-card {
    padding: 20px 18px;
  }

  .multi-turn-section {
    padding: 16px;
  }

  .forbidden-container {
    padding: 14px;
  }
}

.publish-card:hover::before {
  left: 100%;
}

/* Flow Selection Card Styling */
.flow-selection-card {
  border-radius: 16px !important;
  border: 1px solid rgba(25, 118, 210, 0.12) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.flow-selection-card:hover {
  border-color: rgba(25, 118, 210, 0.3) !important;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08) !important;
}

.flow-card-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(25, 118, 210, 0.08) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.flow-selector-wrapper {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.flow-selector-wrapper:hover {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Enhanced Flow Select */
.flow-select-enhanced :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  background: white;
  height: 48px;
}

.autocomplete-field-c :deep(.v-field__field) {
  padding-top: 3px;
}

/* Flow Selection Display */
.flow-selection-display {
  padding: 4px 0;
  width: 100%;
}

/* Flow Dropdown Items */
.flow-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
  padding: 12px 16px !important;
}

.flow-list-item:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  transform: translateX(4px);
}

/* Flow Status Display */
.flow-status-display {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.flow-status-display:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.flow-status-content {
  padding: 8px 0;
}

.flow-connected,
.flow-disconnected {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Enhanced Info Button */
.info-btn-enhanced {
  position: relative;
  transition: all 0.2s ease;
}

.info-btn-enhanced:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
  transform: scale(1.1);
}

/* Dropdown Enhancements */
.flow-select-enhanced :deep(.v-overlay__content) {
  border-radius: 16px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.flow-select-enhanced :deep(.v-list) {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
}

/* Chip Animations */
.flow-connected .v-chip,
.flow-disconnected .v-chip {
  animation: chipPulse 2s ease-in-out infinite;
}

@keyframes chipPulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .flow-selector-wrapper,
  .flow-status-display {
    margin-bottom: 16px;
  }

  .flow-card-header {
    padding: 16px !important;
  }

  .flow-card-header .text-h6 {
    font-size: 1.1rem !important;
  }
}

/* Icon Animations */
.flow-selection-card .v-icon {
  transition: all 0.2s ease;
}

.flow-selection-card:hover .v-icon {
  transform: scale(1.05);
}

.model-type-toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  height: 48px;
  border-radius: 14px;
  padding: 8px;
}

.description-field :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 50px;
}

.description-field :deep(.v-field__input) {
  padding-top: 13px !important;
}

.rounded-input :deep(.v-field) {
  border-radius: 12px !important;
  min-height: 44px;
}
.input--enabled :deep(.v-field) {
  background-color: #ffffff !important;
}
.input--disabled :deep(.v-field) {
  background-color: #ffffff !important;
  color: rgba(55, 65, 81, 0.6) !important;
}
.input--disabled :deep(.v-field__input),
.input--disabled :deep(.v-select__selection-text),
.input--disabled :deep(input) {
  color: rgba(55, 65, 81, 0.6) !important;
}
.padding-input :deep(.v-field) {
  padding-top: 5px !important;
}
.padding-input2 :deep(.v-field) {
  padding-top: 4px !important;
}

.dialog-close-btn {
  border: 1px solid #c32e0e !important; /* red outline */
  color: #c32e0e !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
  box-shadow: none !important;
}
.dialog-close-btn .v-icon {
  margin-right: 6px;
}

.required-name-dialog {
  border-radius: 12px !important;
  background: #ffffff;
  border: 1px solid #f4d6b8;
}

.required-name-header {
  background: linear-gradient(900deg, #fff8ed, #fff0da);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffa726;
}

.required-body {
  padding: 16px;
}

.required-name-message {
  font-size: 14px;
  color: #171717;
}

.required-field-list {
  margin: 10px 0 0;
  padding-left: 22px;
  color: #171717;
  font-size: 14px;
  line-height: 1.7;
}

.required-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 26px;
}

.ok-required-btn {
  border-radius: 10px;
  font-weight: 500;
  font-size: 13px;
  color: #ffffff !important;
  width: 80px;
  background: #a26a18;
  padding: 8px;
}

.dialog-save-btn {
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn-green {
  background: #03892b !important; /* green gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn .v-icon {
  margin-right: 6px;
}
.flow-not-selected {
  background: #75767b !important;
  color: white !important;
}
.flow-selected {
  background: #eaf9ee !important;
  color: #03832a !important;
}
.chipdiv {
  margin-right: 15px;
  gap: 10px;
}
.chipspan {
  color: #646464;
  font-family: var(--Poppins-Font, Poppins);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.model-option-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
}

.model-option-meta {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 45%;
}

.model-option-meta-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.model-option-meta-separator {
  flex: 0 0 auto;
  color: #cbd5e1;
}

.model-selection-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-menu-trigger {
  margin-left: 8px;
  height: 32px !important;
  padding: 0 10px !important;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f8fafc;
  text-transform: none !important;
  letter-spacing: normal !important;
  min-width: 0 !important;
}

.category-menu-trigger :deep(.v-btn__content) {
  display: flex;
  align-items: center;
}

.category-menu-text {
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-menu-text--placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.category-menu-list {
  min-width: 220px;
}

.category-menu-new__title {
  color: #1976D2;
  font-weight: 600;
  font-size: 13px;
}

.category-menu-empty {
  color: #94a3b8;
  font-size: 12px;
  font-style: italic;
}

.model-provider-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.model-provider-pill {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  padding: 2px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f8fafc;
  line-height: 1.4;
}

.model-provider-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  margin-right: 4px;
  white-space: nowrap;
}

.model-provider-value {
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
